(function (window) {
  "use strict";

  function normalizeDeliveryTypeKey(type) {
    var normalized = String(type || "")
      .trim()
      .toLowerCase()
      .replace(/[\s_-]+/g, "");
    if (
      normalized === "pickup" ||
      normalized === "pickuppoint" ||
      normalized === "pudo" ||
      normalized === "parcelshop"
    ) {
      return "pickup";
    }
    if (
      normalized === "courier" ||
      normalized === "door" ||
      normalized === "doortodoor"
    ) {
      return "courier";
    }
    return normalized;
  }

  var TYPE_LABELS = {
    ru: {
      courier: "Курьером",
      pickup: "Самовывоз",
      COURIER: "Курьером",
      PICKUP: "Самовывоз",
      PICKUP_POINT: "Самовывоз",
      PICKUPPOINT: "Самовывоз",
      door: "Курьером",
      pickuppoint: "Самовывоз",
    },
    en: {
      courier: "Courier",
      pickup: "Pickup",
      COURIER: "Courier",
      PICKUP: "Pickup",
      PICKUP_POINT: "Pickup",
      PICKUPPOINT: "Pickup",
      door: "Courier",
      pickuppoint: "Pickup",
    },
  };

  function labelForDeliveryType(type, locale) {
    var map = TYPE_LABELS[locale] || TYPE_LABELS.en;
    if (!type) {
      return "";
    }
    if (map[type]) {
      return map[type];
    }
    var upper = String(type).toUpperCase();
    if (map[upper]) {
      return map[upper];
    }
    var lower = String(type).toLowerCase();
    if (map[lower]) {
      return map[lower];
    }
    var compact = lower.replace(/[\s_-]+/g, "");
    if (map[compact]) {
      return map[compact];
    }
    var bucket = normalizeDeliveryTypeKey(type);
    if (bucket === "pickup") {
      return map.pickup;
    }
    if (bucket === "courier") {
      return map.courier || map.door;
    }
    return type;
  }

  var NUMERIC_COUNTRY_CODES = {
    428: "LV",
    233: "EE",
    440: "LT",
    276: "DE",
    250: "FR",
    826: "GB",
    840: "US",
    643: "RU",
    616: "PL",
    752: "SE",
    578: "NO",
    246: "FI",
    804: "UA",
    112: "BY",
  };

  function numericCountryCodeToAlpha2(code) {
    var numeric = parseInt(code, 10);
    if (!Number.isFinite(numeric)) {
      return "";
    }
    return NUMERIC_COUNTRY_CODES[numeric] || "";
  }

  function alpha2CountryCodeToNumeric(alpha2) {
    var upper = String(alpha2 || "").trim().toUpperCase();
    if (!upper) {
      return null;
    }
    var keys = Object.keys(NUMERIC_COUNTRY_CODES);
    for (var i = 0; i < keys.length; i += 1) {
      var numeric = keys[i];
      if (NUMERIC_COUNTRY_CODES[numeric] === upper) {
        return parseInt(numeric, 10);
      }
    }
    return null;
  }

  var COUNTRY_NAMES = {
    en: {
      LV: "Latvia",
      EE: "Estonia",
      LT: "Lithuania",
      DE: "Germany",
      FR: "France",
      GB: "United Kingdom",
      US: "United States",
      RU: "Russia",
      PL: "Poland",
      SE: "Sweden",
      NO: "Norway",
      FI: "Finland",
      UA: "Ukraine",
      BY: "Belarus",
    },
    ru: {
      LV: "Латвия",
      EE: "Эстония",
      LT: "Литва",
      DE: "Германия",
      FR: "Франция",
      GB: "Великобритания",
      US: "США",
      RU: "Россия",
      PL: "Польша",
      SE: "Швеция",
      NO: "Норвегия",
      FI: "Финляндия",
      UA: "Украина",
      BY: "Беларусь",
    },
  };

  function countryNameForAlpha2(alpha2, locale) {
    var upper = String(alpha2 || "").trim().toUpperCase();
    if (!upper) {
      return "";
    }
    var normalizedLocale = locale === "ru" ? "ru" : "en";
    var map = COUNTRY_NAMES[normalizedLocale] || COUNTRY_NAMES.en;
    return (map && map[upper]) || COUNTRY_NAMES.en[upper] || upper;
  }

  function formatLabel(label_name, locale, countryAlpha2) {
    var copy = (window.FiluetShipIndexI18n && window.FiluetShipIndexI18n.I18N
      ? window.FiluetShipIndexI18n.I18N[locale] || window.FiluetShipIndexI18n.I18N.en
      : null);
    var base = (copy && copy[label_name]) || label_name.charAt(0).toUpperCase() + label_name.slice(1);
    var postfix = countryAlpha2 ? String(countryAlpha2).toUpperCase() : "";
    if (!postfix) {
      return base;
    }
    return copy[label_name + "_" + postfix];
  }

  window.FiluetShipIndexI18n = {
    I18N: {
      ru: {
        deliveryTypeLabel: "Тип доставки",
        loading: "Загрузка…",
        noDeliveryTypes: "Типы доставки не найдены.",
        loadFailed: "Не удалось загрузить типы доставки.",
        language: "Язык",
        activeAddressLabel: "Адрес доставки",
        addressLoading: "Загрузка адреса…",
        noActiveAddress: "Активный адрес не выбран",
        addressLoadFailed: "Не удалось загрузить адрес",
        noCustomerId: "Не указан customerId",
        calculationPayloadLoadFailed: "Не удалось загрузить данные заказа",
        calculationPayloadAlreadyConfirmed:
          "Отправление уже создано. Сейчас его нельзя изменить.",
        shippingRatesLabel: "Способы доставки",
        shippingRatesLoading: "Загрузка способов доставки…",
        shippingNotPossible: "Доставка невозможна",
        shippingRatesLoadFailed: "Не удалось загрузить способы доставки",
        shippingRateFallback: "Тариф",
        shippingRatesPrev: "Предыдущие тарифы",
        shippingRatesNext: "Следующие тарифы",
        shippingRatesConfirming: "Подтверждение…",
        shippingRatesConfirmFailed: "Не удалось подтвердить тариф",
        rateDeliveryDaysRange: "{{min}}–{{max}} дн.",
        rateDeliveryDaysSingle: "{{days}} дн.",
        rateServiceCodeLabel: "Код услуги",
        rateDeliveryTypeLabel: "Тип доставки",
        rateCustomerAmountLabel: "Стоимость доставки",
        selectAddress: "Выбрать адрес",
        selectAddressTitle: "Выберите адрес доставки",
        confirm: "Подтвердить",
        done: "Готово",
        ok: "OK",
        noAddressesAvailable: "Нет сохранённых адресов",
        addressConfirmFailed: "Не удалось сохранить адрес",
        add: "Добавить<br>пункт выдачи, постамат, адрес доставки",
        add_LV: "Добавить<br><span style=\"display:block;font-size:0.8em;margin:0;text-align:center;\">пакомат или адрес доставки</span>",
        newAddressTitle: "Новый адрес",
        newAddressCity: "Город",
        newAddressCityPlaceholder: "Выберите город",
        newAddressCityInvalid: "Выберите город из списка",
        citiesLoading: "Загружаем города...",
        noCitiesAvailable: "Нет доступных городов",
        citiesLoadFailed: "Не удалось загрузить города",
        newAddressLine: "Адрес",
        newAddressPickupPoint: "Пункт выдачи",
        newAddressPickupPointPlaceholder: "Выберите пункт выдачи",
        newAddressPickupPointSelectCity: "Сначала выберите город",
        newAddressPickupPointInvalid: "Выберите пункт выдачи из списка",
        pickupPointsLoading: "Загрузка пунктов выдачи…",
        noPickupPointsAvailable: "Нет пунктов выдачи в этом городе",
        pickupPointsLoadFailed: "Не удалось загрузить пункты выдачи",
        newAddressCountry: "Страна",
        newAddressCountryPlaceholder: "Выберите страну",
        countriesLoading: "Ищем страны...",
        noCountriesAvailable: "Нет доступных стран",
        countriesLoadFailed: "Не удалось загрузить страны",
        newAddressContactFirstName: "Имя",
        newAddressContactLastName: "Фамилия",
        newAddressContactEmail: "Эл. почта",
        newAddressContactPhone: "Телефон получателя",
        newAddressLineRequired: "Введите адрес доставки",
        newAddressContactFirstNameRequired: "Введите имя",
        newAddressContactLastNameRequired: "Введите фамилию",
        newAddressContactEmailRequired: "Введите эл. почту",
        newAddressContactEmailInvalid: "Неверный адрес эл. почты",
        newAddressContactPhoneRequired: "Введите телефон получателя",
        newAddressContactPhoneInvalid: "Неверный номер телефона",
        newAddressContactPhoneCountryInvalid: "Неверный номер телефона",
        newAddressPostalCodeUndetermined: "Не удалось определить почтовый индекс",
        save: "Сохранить",
        cancel: "Отмена",
        newAddressCreateFailed: "Не удалось создать адрес",
        changeAddressTitle: "Сменить адрес",
        addressFilterPlaceholder: "Поиск по адресу, городу, контактам…",
        addressFilterNoResults: "Нет адресов по вашему запросу",
        addressUpdateFailed: "Не удалось обновить адрес",
        addressDeleteFailed: "Не удалось удалить адрес",
        addressDeleteConfirm: "Удалить этот адрес?",
        addressCopyFailed: "Не удалось скопировать адрес",
        addressMenuLabel: "Действия с адресом",
        edit: "Изменить",
        delete: "Удалить",
        copy: "Копировать",
        companyCountryUnavailable: "Не удалось определить страну компании",
        mapRequiresKey: "Для карты нужен ключ Google Maps",
      },
      en: {
        deliveryTypeLabel: "Delivery type",
        loading: "Loading…",
        noDeliveryTypes: "No delivery types returned.",
        loadFailed: "Failed to load delivery types.",
        language: "Language",
        activeAddressLabel: "Delivery address",
        addressLoading: "Loading address…",
        noActiveAddress: "No active address selected",
        addressLoadFailed: "Failed to load address",
        noCustomerId: "customerId is not configured",
        calculationPayloadLoadFailed: "Failed to load order data",
        calculationPayloadAlreadyConfirmed:
          "The shipment has already created. You can't edit it right now",
        shippingRatesLabel: "Shipping options",
        shippingRatesLoading: "Loading shipping options…",
        shippingNotPossible: "Shipping not possible",
        shippingRatesLoadFailed: "Failed to load shipping options",
        shippingRateFallback: "Rate",
        shippingRatesPrev: "Previous rates",
        shippingRatesNext: "Next rates",
        shippingRatesConfirming: "Confirming…",
        shippingRatesConfirmFailed: "Failed to confirm rate",
        rateDeliveryDaysRange: "{{min}}–{{max}} days",
        rateDeliveryDaysSingle: "{{days}} days",
        rateServiceCodeLabel: "Service code",
        rateDeliveryTypeLabel: "Delivery type",
        rateCustomerAmountLabel: "Delivery cost",
        selectAddress: "Select address",
        selectAddressTitle: "Select delivery address",
        confirm: "Confirm",
        done: "Done",
        ok: "OK",
        noAddressesAvailable: "No saved addresses",
        addressConfirmFailed: "Failed to save address",
        add: "Add<br>pickup point, parcel locker, delivery address",
        add_LV: "Add<br><span style=\"display:block;font-size:0.8em;margin:0;text-align:center;\">packomat or delivery address<span>",
        newAddressTitle: "New address",
        newAddressCity: "City",
        newAddressCityPlaceholder: "Select a city",
        newAddressCityInvalid: "Select a city from the list",
        citiesLoading: "Loading cities…",
        noCitiesAvailable: "No cities available",
        citiesLoadFailed: "Failed to load cities",
        newAddressLine: "Address",
        newAddressPickupPoint: "Pickup point",
        newAddressPickupPointPlaceholder: "Select a pickup point",
        newAddressPickupPointSelectCity: "Select a city first",
        newAddressPickupPointInvalid: "Select a pickup point from the list",
        pickupPointsLoading: "Loading pickup points…",
        noPickupPointsAvailable: "No pickup points in this city",
        pickupPointsLoadFailed: "Failed to load pickup points",
        newAddressCountry: "Country",
        newAddressCountryPlaceholder: "Select a country",
        countriesLoading: "Loading countries…",
        noCountriesAvailable: "No countries available",
        countriesLoadFailed: "Failed to load countries",
        newAddressContactFirstName: "First name",
        newAddressContactLastName: "Last name",
        newAddressContactEmail: "Email",
        newAddressContactPhone: "Recipient phone",
        newAddressLineRequired: "Enter a delivery address",
        newAddressContactFirstNameRequired: "Enter first name",
        newAddressContactLastNameRequired: "Enter last name",
        newAddressContactEmailRequired: "Enter email",
        newAddressContactEmailInvalid: "Invalid email address",
        newAddressContactPhoneRequired: "Enter recipient phone",
        newAddressContactPhoneInvalid: "Invalid phone number",
        newAddressContactPhoneCountryInvalid: "Invalid phone number",
        newAddressPostalCodeUndetermined: "The postal code could not be determined",
        save: "Save",
        cancel: "Cancel",
        newAddressCreateFailed: "Failed to create address",
        changeAddressTitle: "Change address",
        addressFilterPlaceholder: "Search by address, city, contact…",
        addressFilterNoResults: "No addresses match your search",
        addressUpdateFailed: "Failed to update address",
        addressDeleteFailed: "Failed to delete address",
        addressDeleteConfirm: "Delete this address?",
        addressCopyFailed: "Failed to copy address",
        addressMenuLabel: "Address actions",
        edit: "Edit",
        delete: "Delete",
        copy: "Copy",
        companyCountryUnavailable: "Unable to resolve company country",
        mapRequiresKey: "Google Maps API key is required",
      },
    },
    TYPE_LABELS: TYPE_LABELS,
    normalizeDeliveryTypeKey: normalizeDeliveryTypeKey,
    labelForDeliveryType: labelForDeliveryType,
    numericCountryCodeToAlpha2: numericCountryCodeToAlpha2,
    alpha2CountryCodeToNumeric: alpha2CountryCodeToNumeric,
    countryNameForAlpha2: countryNameForAlpha2,
    formatLabel: formatLabel,
  };
})(window);


(function (window) {
  "use strict";

  function joinUrl(base, path) {
    return String(base || "").replace(/\/+$/, "") + path;
  }

  function FiluetShipApi(options) {
    options = options || {};
    this.apiBaseUrl = options.apiBaseUrl || "";
    this.apiKey = options.apiKey || "";
    this.companyId = options.companyId || "";
    this.environment = options.environment || "TEST";
    this.accessToken = options.accessToken || "";
    this.accessTokenExpiresAt = 0;
    this.ratesEndpoint = options.ratesEndpoint || "";
    this.pickupPointsEndpoint = options.pickupPointsEndpoint || "";
    this.confirmEndpoint = options.confirmEndpoint || "";
    this.serviceUrls = {
      deliveryCore: options.deliveryCoreUrl || (options.serviceUrls && options.serviceUrls.deliveryCore) || "",
      authIdentity: options.authIdentityUrl || (options.serviceUrls && options.serviceUrls.authIdentity) || "",
      clientCore: options.clientCoreUrl || (options.serviceUrls && options.serviceUrls.clientCore) || "",
    };
    this._tokenExchangePromise = null;
  }

  FiluetShipApi.prototype.resolveUrl = function (service, path) {
    var direct = this.serviceUrls && this.serviceUrls[service];
    if (direct) {
      return joinUrl(direct, path);
    }
    return joinUrl(this.apiBaseUrl, path);
  };

  FiluetShipApi.prototype.parseTokenExpiry = function (token) {
    if (!token) {
      return 0;
    }
    try {
      var parts = String(token).split(".");
      if (parts.length < 2) {
        return 0;
      }
      var payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
      while (payload.length % 4) {
        payload += "=";
      }
      var decoded = JSON.parse(atob(payload));
      return decoded.exp ? decoded.exp * 1000 : 0;
    } catch (e) {
      return 0;
    }
  };

  FiluetShipApi.prototype.buildHeaders = function (extra, opts) {
    opts = opts || {};
    var headers = Object.assign({}, extra || {});
    var hasBody = opts.withJsonBody !== false;
    if (hasBody && !headers["Content-Type"] && !headers["content-type"]) {
      headers["Content-Type"] = "application/json";
    }
    if (opts.useApiKey && this.apiKey) {
      headers["X-API-Key"] = this.apiKey;
    }
    if (!opts.skipAuth && this.accessToken) {
      headers["Authorization"] = "Bearer " + this.accessToken;
    }
    if (opts.environment || this.environment) {
      headers["X-Environment"] = opts.environment || this.environment;
    }
    if (opts.idempotencyKey) {
      headers["Idempotency-Key"] = opts.idempotencyKey;
    }
    var companyId = opts.companyId || this.companyId;
    if (companyId) {
      headers["X-Company-Id"] = companyId;
    }
    return headers;
  };

  FiluetShipApi.prototype.exchangeApiKeyForToken = function () {
    var self = this;
    if (!self.apiKey) {
      return Promise.reject(new Error("missing_api_key"));
    }
    if (self._tokenExchangePromise) {
      return self._tokenExchangePromise;
    }
    self._tokenExchangePromise = self
      .request(self.resolveUrl("authIdentity", "/v1/auth/api-key/token"), {
        method: "POST",
        errorCode: "auth_token_failed",
        withJsonBody: false,
        skipAuth: true,
        useApiKey: true,
      })
      .then(function (data) {
        self.accessToken = (data && data.access_token) || "";
        self.accessTokenExpiresAt =
          self.parseTokenExpiry(self.accessToken) ||
          Date.now() + ((data && data.expires_in) || 900) * 1000;
        if (data && data.company_id && !self.companyId) {
          self.companyId = data.company_id;
        }
        return self.accessToken;
      })
      .finally(function () {
        self._tokenExchangePromise = null;
      });
    return self._tokenExchangePromise;
  };

  FiluetShipApi.prototype.ensureAccessToken = function () {
    if (this.accessToken && !this.apiKey) {
      return Promise.resolve(this.accessToken);
    }
    if (!this.apiKey) {
      return Promise.reject(new Error("missing_api_key"));
    }
    var expiresSoon = !this.accessTokenExpiresAt || this.accessTokenExpiresAt - Date.now() < 60000;
    if (!this.accessToken || expiresSoon) {
      return this.exchangeApiKeyForToken();
    }
    return Promise.resolve(this.accessToken);
  };

  FiluetShipApi.prototype.request = function (url, options) {
    options = options || {};
    var self = this;

    function performRequest(retryOnUnauthorized) {
      var headers = self.buildHeaders(options.headers, options);
      var fetchOptions = {
        method: options.method || "GET",
        headers: headers,
      };
      if (options.body !== undefined && options.body !== null) {
        fetchOptions.body =
          typeof options.body === "string" ? options.body : JSON.stringify(options.body);
      }
      return fetch(url, fetchOptions).then(function (resp) {
        if (resp.status === 401 && retryOnUnauthorized && self.apiKey && !options.skipAuth) {
          self.accessToken = "";
          self.accessTokenExpiresAt = 0;
          return self.exchangeApiKeyForToken().then(function () {
            return performRequest(false);
          });
        }
        if (!resp.ok) {
          return resp.text().then(function (text) {
            var err = new Error(options.errorCode || "request_failed");
            err.status = resp.status;
            err.body = text;
            throw err;
          });
        }
        if (resp.status === 204) {
          return null;
        }
        var contentType = resp.headers.get("content-type") || "";
        if (contentType.indexOf("application/json") !== -1) {
          return resp.json();
        }
        return resp.text();
      });
    }

    if (options.skipAuth) {
      return performRequest(false);
    }
    return this.ensureAccessToken().then(function () {
      return performRequest(true);
    });
  };

  FiluetShipApi.prototype.normalizeCalculationResponse = function (data, providerCode) {
    var normalized = {
      rates: [],
      calculation_id: null,
      status: null,
      parcels: [],
      packer_boxes: [],
      raw: data,
    };
    var item = null;
    if (Array.isArray(data)) {
      item =
        data.find(function (entry) {
          return !providerCode || entry.provider_code === providerCode;
        }) || data[0];
    } else if (data && typeof data === "object") {
      item = data;
    }
    if (!item) {
      return normalized;
    }
    normalized.rates = item.rates || [];
    normalized.calculation_id = item.calculation_id || item.id || null;
    normalized.status = item.status || null;
    normalized.parcels = Array.isArray(item.parcels) ? item.parcels : [];
    normalized.packer_boxes = Array.isArray(item.packer_boxes) ? item.packer_boxes : [];
    return normalized;
  };

  // --- auth-identity (direct or via gateway when routed) ---

  FiluetShipApi.prototype.getAuthToken = function (payload) {
    return this.request(this.resolveUrl("authIdentity", "/v1/auth/token"), {
      method: "POST",
      body: payload,
      errorCode: "auth_token_failed",
      withJsonBody: true,
      skipAuth: true,
    });
  };

  FiluetShipApi.prototype.getUserInfo = function () {
    return this.request(this.resolveUrl("authIdentity", "/v1/auth/userinfo"), {
      errorCode: "userinfo_failed",
      withJsonBody: false,
    });
  };

  FiluetShipApi.prototype.verifyApiKey = function (apiKey) {
    return this.request(this.resolveUrl("authIdentity", "/v1/auth/api-key/verify"), {
      method: "POST",
      body: { api_key: apiKey || this.apiKey },
      errorCode: "api_key_verify_failed",
      skipAuth: true,
      useApiKey: true,
    });
  };

  // --- client-core ---

  FiluetShipApi.prototype.getClientTenantSettings = function () {
    return this.request(this.resolveUrl("clientCore", "/v1/clients/tenants/tenant-settings"), {
      errorCode: "tenant_settings_failed",
      withJsonBody: false,
    });
  };

  FiluetShipApi.prototype.getCompany = function () {
    return this.request(this.resolveUrl("clientCore", "/v1/clients/company"), {
      errorCode: "company_failed",
      withJsonBody: false,
    });
  };

  // --- delivery-core (via gateway or direct) ---

  FiluetShipApi.prototype.getTenantSettings = function () {
    var self = this;
    return this.request(joinUrl(this.apiBaseUrl, "/v1/tenant-settings/current"), {
      errorCode: "tenant_settings_failed",
      withJsonBody: false,
    }).catch(function () {
      if (self.serviceUrls.clientCore || self.accessToken || self.apiKey) {
        return self.getClientTenantSettings();
      }
      throw new Error("tenant_settings_failed");
    });
  };

  FiluetShipApi.prototype.calculateRates = function (payload) {
    var self = this;
    var endpoint =
      this.ratesEndpoint ||
      this.resolveUrl("deliveryCore", "/v1/calculate") ||
      joinUrl(this.apiBaseUrl, "/v1/calculate");
    return this.request(endpoint, {
      method: "POST",
      body: payload,
      errorCode: "rates_failed",
    }).then(function (data) {
      return self.normalizeCalculationResponse(data, payload && payload.provider_code);
    });
  };

  FiluetShipApi.prototype.getCalculation = function (calculationId) {
    return this.request(
      this.resolveUrl("deliveryCore", "/v1/calculations/" + encodeURIComponent(calculationId)),
      {
        errorCode: "calculation_failed",
        withJsonBody: false,
      }
    );
  };

  FiluetShipApi.prototype.confirmCalculation = function (calculationId, body) {
    var endpoint =
      this.confirmEndpoint ||
      this.resolveUrl(
        "deliveryCore",
        "/v1/calculations/" + encodeURIComponent(calculationId) + "/confirm"
      );
    return this.request(endpoint, {
      method: "POST",
      body: body,
      errorCode: "confirm_failed",
    });
  };

  FiluetShipApi.prototype.listPickupPoints = function (query) {
    query = query || {};
    var endpoint = this.pickupPointsEndpoint || this.resolveUrl("deliveryCore", "/v1/pickup-points");
    var params = [];
    Object.keys(query).forEach(function (key) {
      var value = query[key];
      if (value !== undefined && value !== null && value !== "") {
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(String(value)));
      }
    });
    var url = endpoint + (params.length ? "?" + params.join("&") : "");
    return this.request(url, {
      errorCode: "points_failed",
      withJsonBody: false,
      headers: {},
    }).then(function (data) {
      if (Array.isArray(data)) {
        return data;
      }
      return (data && data.pickup_points) || [];
    });
  };

  FiluetShipApi.prototype.createShipment = function (body, opts) {
    opts = opts || {};
    return this.request(this.resolveUrl("deliveryCore", "/v1/shipments"), {
      method: "POST",
      body: body,
      errorCode: "shipment_failed",
      idempotencyKey: opts.idempotencyKey,
      environment: opts.environment,
    });
  };

  FiluetShipApi.prototype.getDeliveryTypes = function () {
    return this.request(this.resolveUrl("deliveryCore", "/v1/delivery/types"), {
      errorCode: "delivery_types_failed",
      withJsonBody: false,
    });
  };

  FiluetShipApi.prototype.getDestinationCountries = function () {
    return this.request(
      this.resolveUrl("deliveryCore", "/v1/delivery/destination-countries"),
      {
        errorCode: "destination_countries_failed",
        withJsonBody: false,
      }
    );
  };

  FiluetShipApi.prototype.getCities = function (countryCode, deliveryType) {
    return this.request(
      this.resolveUrl(
        "deliveryCore",
        "/v1/cities/" +
          encodeURIComponent(countryCode || "") +
          "/" +
          encodeURIComponent(deliveryType || "")
      ),
      {
        errorCode: "cities_failed",
        withJsonBody: false,
      }
    );
  };

  FiluetShipApi.prototype.listDeliveryAddresses = function (customerId) {
    return this.request(
      this.resolveUrl(
        "deliveryCore",
        "/v1/delivery/addresses/" + encodeURIComponent(customerId)
      ),
      {
        errorCode: "delivery_addresses_failed",
        withJsonBody: false,
      }
    );
  };

  FiluetShipApi.prototype.getCalculationPayload = function (payloadId) {
    return this.request(
      this.resolveUrl(
        "deliveryCore",
        "/v1/calculation-payloads/" + encodeURIComponent(payloadId)
      ),
      {
        errorCode: "calculation_payload_failed",
        withJsonBody: false,
      }
    );
  };

  FiluetShipApi.prototype.getRatesForCalculationPayload = function (body) {
    return this.request(this.resolveUrl("deliveryCore", "/v1/rates"), {
      method: "POST",
      body: body || {},
      errorCode: "rates_failed",
    }).then(function (data) {
      if (Array.isArray(data)) {
        return { rates: data };
      }
      return {
        rates: (data && data.rates) || [],
      };
    });
  };

  FiluetShipApi.prototype.selectRate = function (calculationPayloadId, selectedRate) {
    return this.request(
      this.resolveUrl(
        "deliveryCore",
        "/v1/select-rate/" + encodeURIComponent(calculationPayloadId)
      ),
      {
        method: "POST",
        body: selectedRate || {},
        errorCode: "select_rate_failed",
      }
    );
  };

  FiluetShipApi.prototype.createDeliveryAddress = function (payload) {
    return this.request(this.resolveUrl("deliveryCore", "/v1/delivery/address"), {
      method: "POST",
      body: payload,
      errorCode: "delivery_address_create_failed",
    });
  };

  FiluetShipApi.prototype.updateDeliveryAddress = function (addressId, payload) {
    return this.request(
      this.resolveUrl("deliveryCore", "/v1/delivery/address/" + encodeURIComponent(addressId)),
      {
        method: "PATCH",
        body: payload,
        errorCode: "delivery_address_update_failed",
      }
    );
  };

  FiluetShipApi.prototype.deleteDeliveryAddress = function (addressId) {
    return this.request(
      this.resolveUrl("deliveryCore", "/v1/delivery/address/" + encodeURIComponent(addressId)),
      {
        method: "DELETE",
        errorCode: "delivery_address_delete_failed",
        withJsonBody: false,
        headers: {},
      }
    );
  };

  FiluetShipApi.create = function (options) {
    return new FiluetShipApi(options);
  };

  window.FiluetShipApi = FiluetShipApi;
})(window);


(function () {
        var cfg = window.FILUETSHIP_WIDGET_CONFIG || {};

        function applyWidgetMaxWidth() {
          var raw = cfg.maxWidth;
          if (raw == null || raw === "") {
            return;
          }
          var numeric = Number(raw);
          if (Number.isFinite(numeric) && numeric > 0) {
            document.documentElement.style.setProperty(
              "--widget-max-width",
              numeric + "px"
            );
            return;
          }
          if (typeof raw === "string" && raw.trim()) {
            document.documentElement.style.setProperty("--widget-max-width", raw.trim());
          }
        }

        function applyWidgetThemeColor() {
          var raw = cfg.themeColor;
          if (raw == null || raw === "") {
            return;
          }
          var hex = String(raw).trim();
          if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(hex)) {
            return;
          }
          if (hex.length === 4) {
            hex =
              "#" +
              hex[1] +
              hex[1] +
              hex[2] +
              hex[2] +
              hex[3] +
              hex[3];
          }
          document.documentElement.style.setProperty(
            "--widget-theme-color",
            hex.toLowerCase()
          );
        }

        applyWidgetMaxWidth();
        applyWidgetThemeColor();

        var api = null;
        var translations = window.FiluetShipIndexI18n || {};
        var I18N = translations.I18N || {};
        var labelForType = translations.labelForDeliveryType
          ? function (type) {
              return translations.labelForDeliveryType(type, locale);
            }
          : function (type) {
              var map = (translations.TYPE_LABELS || {})[locale] || {};
              return map[type] || type;
            };

        var row = document.getElementById("delivery-type-row");
        var errorNode = document.getElementById("delivery-type-error");
        var addressCard = document.getElementById("delivery-address-card");
        var shippingRatesSection = document.getElementById("shipping-rates-section");
        var shippingRatesPanel = document.getElementById("shipping-rates-panel");
        var shippingRatesConfirm = document.getElementById("shipping-rates-confirm");
        var shippingRatesConfirmError = document.getElementById("shipping-rates-confirm-error");
        var widgetErrorPopup = document.getElementById("widget-error-popup");
        var widgetErrorPopupMessage = document.getElementById("widget-error-popup-message");
        var deliveryAddressEdit = document.getElementById("delivery-address-edit");
        var addressModal = document.getElementById("address-modal");
        var addressModalList = document.getElementById("address-modal-list");
        var addressModalAdd = document.getElementById("address-modal-add");
        var addressModalConfirm = document.getElementById("address-modal-confirm");
        var addressModalError = document.getElementById("address-modal-error");
        var addressModalTitle = document.getElementById("address-modal-title");
        var addressModalFilter = document.getElementById("address-modal-filter");
        var addressModalFilterWrap = document.getElementById("address-modal-filter-wrap");
        var newAddressModal = document.getElementById("new-address-modal");
        var newAddressForm = document.getElementById("new-address-form");
        var newAddressModalTitle = document.getElementById("new-address-modal-title");
        var newAddressModalError = document.getElementById("new-address-modal-error");
        var newAddressModalSave = document.getElementById("new-address-modal-save");
        var newAddressModalCancel = document.getElementById("new-address-modal-cancel");
        var newAddressDeliveryTypeRow = document.getElementById("new-address-delivery-type-row");
        var newAddressMapContainer = document.getElementById("new-address-map");

        var selectedType = null;
        var newAddressDeliveryType = null;
        var newAddressCountriesRequestId = 0;
        var newAddressDestinationCountries = [];
        var newAddressSelectedCountryAlpha2 = "";
        var newAddressPendingPrefillCountryAlpha2 = "";
        var newAddressCitiesRequestId = 0;
        var newAddressCities = [];
        var newAddressPickupPointsRequestId = 0;
        var newAddressPickupPoints = [];
        var newAddressPickupPointsLoadedCity = "";
        var newAddressPickupPointsLoadingCity = "";
        var newAddressPrefill = null;
        var pendingPickupPointId = null;
        var editingAddressId = null;
        var newAddressIsCopy = false;
        var newAddressEditorBootstrapActive = false;
        var newAddressEditorCitiesReady = false;
        var newAddressEditorPickupPointsReady = false;
        var newAddressPickupPointsLoadPending = 0;
        var newAddressEditorRequiresPickupPoints = false;
        var newAddressEditorSharedCity = "";
        var newAddressCountryDrafts = {};
        var newAddressDeliveryTypeDrafts = {
          pickup: { pickupPointId: "", pickupPointLabel: "" },
          courier: { addressLine: "" },
        };
        var openAddressMenuId = null;
        var newAddressMapInstance = null;
        var newAddressMapsPromise = null;
        var newAddressCityMarker = null;
        var newAddressMapMarkers = [];
        var newAddressMapGeocodeRequestId = 0;
        var newAddressPostalCode = "";
        var newAddressPostalCodePending = false;
        var newAddressPostalCodeBeforeLookup = "";
        var newAddressPostalCodeError = document.getElementById("new-address-postal-code-error");
        var loadedTypes = [];
        var deliveryTypesLoadState = "loading";
        var loadedAddresses = [];
        var addressLoadState = "loading";
        var calculationPayloadId = "";
        var widgetMode = "delivery-settings";
        var calculationPayloadConfirmed = false;
        var ratesLoadState = "idle";
        var loadedRates = [];
        var selectedRateIndex = 0;
        var ratesCarouselOffset = 0;
        var RATES_CAROUSEL_VISIBLE_COUNT = 3;
        var selectRateState = "idle";
        var ratesRequestSequence = 0;
        var lastRatesAddressId = null;
        var modalSelectedAddressId = null;
        var modalConfirming = false;
        var addressActivationSequence = 0;
        var modalAutoOpenedForType = null;
        var newAddressSaving = false;
        var companyCountryCode = null;
        var companyCountryAlpha2 = "";
        var widgetRefreshTimerId = null;

        var COUNTRY_MAP_VIEW = {
          LV: { lat: 56.8796, lng: 24.6032, zoom: 7 },
          EE: { lat: 58.5953, lng: 25.0136, zoom: 7 },
          LT: { lat: 55.1694, lng: 23.8813, zoom: 7 },
          DE: { lat: 51.1657, lng: 10.4515, zoom: 6 },
          FR: { lat: 46.2276, lng: 2.2137, zoom: 6 },
          GB: { lat: 55.3781, lng: -3.436, zoom: 6 },
          US: { lat: 39.8283, lng: -98.5795, zoom: 4 },
          RU: { lat: 61.524, lng: 105.3188, zoom: 3 },
          PL: { lat: 51.9194, lng: 19.1451, zoom: 6 },
          SE: { lat: 60.1282, lng: 18.6435, zoom: 5 },
          NO: { lat: 60.472, lng: 8.4689, zoom: 5 },
          FI: { lat: 61.9241, lng: 25.7482, zoom: 5 },
          UA: { lat: 48.3794, lng: 31.1656, zoom: 6 },
          BY: { lat: 53.7098, lng: 27.9534, zoom: 6 },
        };

        function normalizeCountryAlpha2(code) {
          return String(code || "").trim().toLowerCase();
        }

        var COUNTRY_DIAL_CODES = {
          lv: "+371",
          lt: "+370",
          ee: "+372",
        };

        function getLibPhoneNumber() {
          return window.libphonenumber || null;
        }

        function getCountryDialCode(alpha2) {
          var normalized = normalizeCountryAlpha2(alpha2);
          if (!normalized) {
            return "";
          }
          var lib = getLibPhoneNumber();
          if (lib && lib.getCountryCallingCode) {
            try {
              return "+" + lib.getCountryCallingCode(normalized.toUpperCase());
            } catch (e) {
              // fall through to static map
            }
          }
          return COUNTRY_DIAL_CODES[normalized] || "";
        }

        function getContactPhoneInput() {
          return newAddressForm
            ? newAddressForm.querySelector('[name="contactPhone"]')
            : null;
        }

        function getContactFirstNameInput() {
          return newAddressForm
            ? newAddressForm.querySelector('[name="contactFirstName"]')
            : null;
        }

        function getContactLastNameInput() {
          return newAddressForm
            ? newAddressForm.querySelector('[name="contactLastName"]')
            : null;
        }

        function getContactEmailInput() {
          return newAddressForm
            ? newAddressForm.querySelector('[name="contactEmail"]')
            : null;
        }

        var CONTACT_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

        function isContactEmailValid(value) {
          return CONTACT_EMAIL_PATTERN.test(String(value || "").trim());
        }

        function getContactPhoneFlagNode() {
          return document.getElementById("new-address-contact-phone-flag");
        }

        function getContactPhoneFieldNode() {
          return document.getElementById("new-address-contact-phone-field");
        }

        function getContactPhonePlaceholder(alpha2) {
          var dialCode = getCountryDialCode(alpha2);
          return dialCode ? dialCode + "..." : "+...";
        }

        function normalizeContactPhoneDialCode(value) {
          var compact = String(value || "")
            .trim()
            .replace(/[\s()\-]/g, "");
          if (!compact || compact.indexOf("+") !== 0) {
            return "";
          }
          var digits = compact.slice(1).replace(/\D/g, "");
          if (!digits) {
            return "";
          }
          return "+" + digits;
        }

        function isKnownDialCode(dialCode) {
          var normalized = normalizeContactPhoneDialCode(dialCode);
          if (!normalized) {
            return false;
          }
          var lib = getLibPhoneNumber();
          if (lib && lib.getCountries && lib.getCountryCallingCode) {
            var countries = lib.getCountries();
            for (var i = 0; i < countries.length; i++) {
              try {
                if ("+" + lib.getCountryCallingCode(countries[i]) === normalized) {
                  return true;
                }
              } catch (e) {
                // ignore invalid metadata entries
              }
            }
          }
          for (var key in COUNTRY_DIAL_CODES) {
            if (COUNTRY_DIAL_CODES[key] === normalized) {
              return true;
            }
          }
          return false;
        }

        function isContactPhoneDialCodeOnly(value) {
          var normalized = normalizeContactPhoneDialCode(value);
          if (!normalized) {
            return false;
          }
          return isKnownDialCode(normalized);
        }

        function detectPhoneCountryAlpha2(value) {
          var lib = getLibPhoneNumber();
          if (!lib || !lib.AsYouType || !value || !String(value).trim()) {
            return "";
          }
          var trimmed = String(value).trim();
          var defaultCountry = getEditorCountryAlpha2() || undefined;
          var asYouType =
            trimmed.indexOf("+") === 0
              ? new lib.AsYouType()
              : new lib.AsYouType(defaultCountry);
          asYouType.input(trimmed);
          var country = asYouType.getCountry();
          return country ? String(country).toLowerCase() : "";
        }

        function parseContactPhoneNumber(value) {
          var lib = getLibPhoneNumber();
          if (!lib || !lib.parsePhoneNumberFromString || !value) {
            return null;
          }
          var trimmed = String(value).trim();
          if (!trimmed) {
            return null;
          }
          var defaultCountry = getEditorCountryAlpha2() || undefined;
          try {
            return lib.parsePhoneNumberFromString(trimmed, defaultCountry) || null;
          } catch (e) {
            return null;
          }
        }

        function isContactPhoneValid(value) {
          var trimmed = String(value || "").trim();
          if (!trimmed) {
            return false;
          }
          var parsed = parseContactPhoneNumber(trimmed);
          return !!(parsed && parsed.isPossible());
        }

        function isAllowExternalPhoneNumber() {
          return cfg.allowExternalPhoneNumber !== false;
        }

        function getContactPhoneCountryAlpha2(value) {
          var parsed = parseContactPhoneNumber(value);
          if (parsed && parsed.country) {
            return String(parsed.country).toLowerCase();
          }
          return detectPhoneCountryAlpha2(value);
        }

        function isContactPhoneMatchingSelectedCountry(value) {
          var selectedCountry = getEditorCountryAlpha2Lower();
          if (!selectedCountry) {
            return true;
          }
          var phoneCountry = getContactPhoneCountryAlpha2(value);
          if (!phoneCountry) {
            return false;
          }
          return phoneCountry === selectedCountry;
        }

        function formatContactPhoneForSave(value) {
          var trimmed = String(value || "").trim();
          if (!trimmed) {
            return "";
          }
          var parsed = parseContactPhoneNumber(trimmed);
          if (parsed && parsed.isPossible()) {
            return parsed.format("E.164");
          }
          return trimmed;
        }

        function updateContactPhoneFlag() {
          var input = getContactPhoneInput();
          var flagNode = getContactPhoneFlagNode();
          var fieldNode = getContactPhoneFieldNode();
          if (!input || !flagNode || !fieldNode) {
            return;
          }
          var country =
            detectPhoneCountryAlpha2(input.value) || getEditorCountryAlpha2Lower();
          if (country) {
            flagNode.className = "new-address-modal__phone-flag fi fi-" + country;
            flagNode.setAttribute("aria-hidden", "false");
            fieldNode.classList.add("has-detected-country");
            return;
          }
          flagNode.className = "new-address-modal__phone-flag fi";
          flagNode.setAttribute("aria-hidden", "true");
          fieldNode.classList.remove("has-detected-country");
        }

        function updateContactPhoneField() {
          var input = getContactPhoneInput();
          if (!input) {
            return;
          }
          input.disabled = isNewAddressEditorLocked();
          var alpha2 = newAddressSelectedCountryAlpha2;
          input.placeholder = getContactPhonePlaceholder(alpha2);
          var trimmed = String(input.value || "").trim();
          var targetDialCode = alpha2 ? getCountryDialCode(alpha2) : "";

          if (!trimmed && targetDialCode) {
            input.value = targetDialCode;
          } else if (
            trimmed &&
            targetDialCode &&
            isContactPhoneDialCodeOnly(trimmed)
          ) {
            var currentDialCode = normalizeContactPhoneDialCode(trimmed);
            if (currentDialCode && currentDialCode !== targetDialCode) {
              input.value = targetDialCode;
            }
          }
          updateContactPhoneFlag();
        }

        function sanitizeContactPhoneInput() {
          var input = getContactPhoneInput();
          if (!input) {
            return;
          }
          var cleaned = input.value.replace(/[^\d+\s()\-]/g, "");
          if (cleaned !== input.value) {
            input.value = cleaned;
          }
          updateContactPhoneFlag();
        }

        function getCountryDisplayName(alpha2) {
          if (translations.countryNameForAlpha2) {
            return translations.countryNameForAlpha2(alpha2, locale);
          }
          var upper = String(alpha2 || "").trim().toUpperCase();
          return upper;
        }

        function getCountryGeocodeName(alpha2) {
          if (translations.countryNameForAlpha2) {
            return translations.countryNameForAlpha2(alpha2, "en");
          }
          var upper = String(alpha2 || "").trim().toUpperCase();
          return upper;
        }

        function getEditorCountryAlpha2() {
          if (newAddressSelectedCountryAlpha2) {
            return String(newAddressSelectedCountryAlpha2).toUpperCase();
          }
          return companyCountryAlpha2 ? String(companyCountryAlpha2).toUpperCase() : "";
        }

        function getEditorCountryAlpha2Lower() {
          var alpha2 = getEditorCountryAlpha2();
          return alpha2 ? alpha2.toLowerCase() : "";
        }

        function resolveSelectedCountryNumericCode() {
          if (
            translations.alpha2CountryCodeToNumeric &&
            newAddressSelectedCountryAlpha2
          ) {
            return translations.alpha2CountryCodeToNumeric(newAddressSelectedCountryAlpha2);
          }
          return null;
        }

        function getNewAddressCountryInput() {
          return newAddressForm.querySelector('[name="country"]');
        }

        function getNewAddressCountryListbox() {
          return document.getElementById("new-address-country-listbox");
        }

        function getNewAddressCountryFlag() {
          return document.getElementById("new-address-country-flag");
        }

        function updateCountryComboboxFlag(alpha2) {
          var flag = getNewAddressCountryFlag();
          if (!flag) {
            return;
          }
          var normalized = normalizeCountryAlpha2(alpha2);
          if (!normalized) {
            flag.hidden = true;
            flag.className = "new-address-modal__country-input-flag fi";
            return;
          }
          flag.hidden = false;
          flag.className =
            "new-address-modal__country-input-flag fi fi-" + normalized;
        }

        function syncCountryComboboxValue(alpha2) {
          var input = getNewAddressCountryInput();
          if (!input) {
            return;
          }
          var normalized = normalizeCountryAlpha2(alpha2);
          if (!normalized) {
            input.value = "";
            delete input.dataset.selectedCountryAlpha2;
            updateCountryComboboxFlag("");
            return;
          }
          input.value = getCountryDisplayName(normalized);
          input.dataset.selectedCountryAlpha2 = normalized;
          updateCountryComboboxFlag(normalized);
        }

        function resolveSelectedCountry(value) {
          var input = getNewAddressCountryInput();
          var trimmed = String(
            value !== undefined ? value : input ? input.value : ""
          ).trim();
          if (!trimmed || !newAddressDestinationCountries.length) {
            return "";
          }
          if (input && input.dataset.selectedCountryAlpha2) {
            var fromDataset = normalizeCountryAlpha2(
              input.dataset.selectedCountryAlpha2
            );
            if (
              fromDataset &&
              newAddressDestinationCountries.indexOf(fromDataset) !== -1 &&
              trimmed.toLowerCase() ===
                getCountryDisplayName(fromDataset).toLowerCase()
            ) {
              return fromDataset;
            }
          }
          var lower = trimmed.toLowerCase();
          var match = newAddressDestinationCountries.find(function (code) {
            return getCountryDisplayName(code).toLowerCase() === lower;
          });
          if (match) {
            return normalizeCountryAlpha2(match);
          }
          var asCode = normalizeCountryAlpha2(trimmed);
          if (asCode && newAddressDestinationCountries.indexOf(asCode) !== -1) {
            return asCode;
          }
          return "";
        }

        function closeCountryCombobox() {
          var listbox = getNewAddressCountryListbox();
          var input = getNewAddressCountryInput();
          if (listbox) {
            listbox.hidden = true;
          }
          if (input) {
            input.setAttribute("aria-expanded", "false");
          }
        }

        function getFilteredCountries(query, options) {
          options = options || {};
          if (!newAddressDestinationCountries.length) {
            return [];
          }
          if (options.showAll) {
            return newAddressDestinationCountries.slice();
          }
          var trimmed = String(query || "").trim().toLowerCase();
          if (!trimmed) {
            return newAddressDestinationCountries.slice();
          }
          return newAddressDestinationCountries.filter(function (code) {
            var name = getCountryDisplayName(code).toLowerCase();
            return name.indexOf(trimmed) !== -1 || code.indexOf(trimmed) !== -1;
          });
        }

        function renderCountryComboboxOptions(options) {
          options = options || {};
          var listbox = getNewAddressCountryListbox();
          var input = getNewAddressCountryInput();
          if (!listbox || !input || input.disabled) {
            return;
          }
          var selectedCountry = resolveSelectedCountry(input.value);
          var filterQuery = options.showAll ? "" : input.value;
          var filteredCountries = getFilteredCountries(filterQuery, options);
          listbox.innerHTML = "";
          filteredCountries.forEach(function (countryCode) {
            var normalized = normalizeCountryAlpha2(countryCode);
            var option = document.createElement("li");
            option.className =
              "new-address-modal__combobox-option new-address-modal__combobox-option--country";
            option.setAttribute("role", "option");
            if (
              selectedCountry &&
              normalized === selectedCountry
            ) {
              option.classList.add("is-selected");
              option.setAttribute("aria-selected", "true");
            } else {
              option.setAttribute("aria-selected", "false");
            }

            var flag = document.createElement("span");
            flag.className = "fi fi-" + normalized + " new-address-modal__country-flag";
            flag.setAttribute("aria-hidden", "true");

            var name = document.createElement("span");
            name.className = "new-address-modal__country-name";
            name.textContent = getCountryDisplayName(normalized);

            option.appendChild(flag);
            option.appendChild(name);
            option.addEventListener("mousedown", function (event) {
              event.preventDefault();
              selectCountryOption(normalized);
            });
            listbox.appendChild(option);
          });
          listbox.hidden = filteredCountries.length === 0;
          input.setAttribute(
            "aria-expanded",
            filteredCountries.length > 0 ? "true" : "false"
          );
          var selectedNode = listbox.querySelector(
            ".new-address-modal__combobox-option.is-selected"
          );
          if (selectedNode) {
            selectedNode.scrollIntoView({ block: "nearest" });
          }
        }

        function openCountryCombobox(options) {
          var input = getNewAddressCountryInput();
          if (!input || input.disabled || !newAddressDestinationCountries.length) {
            return;
          }
          renderCountryComboboxOptions(options);
        }

        function selectCountryOption(countryCode) {
          var normalized = normalizeCountryAlpha2(countryCode);
          if (!normalized) {
            return;
          }
          if (normalized === newAddressSelectedCountryAlpha2) {
            syncCountryComboboxValue(normalized);
            closeCountryCombobox();
            return;
          }
          setNewAddressCountry(normalized);
        }

        function setCountryComboboxState(disabled, placeholder, countryAlpha2) {
          var input = getNewAddressCountryInput();
          if (!input) {
            return;
          }
          input.disabled = !!disabled;
          input.placeholder = placeholder || "";
          if (countryAlpha2 !== undefined) {
            if (countryAlpha2) {
              syncCountryComboboxValue(countryAlpha2);
            } else {
              input.value = "";
              delete input.dataset.selectedCountryAlpha2;
              updateCountryComboboxFlag("");
            }
          }
          closeCountryCombobox();
        }

        function setCountryComboboxDisabled(disabled) {
          var input = getNewAddressCountryInput();
          if (input) {
            input.disabled = !!disabled;
          }
        }

        function syncCountryComboboxDisplay() {
          if (newAddressSelectedCountryAlpha2) {
            syncCountryComboboxValue(newAddressSelectedCountryAlpha2);
            return;
          }
          var input = getNewAddressCountryInput();
          if (input && !input.disabled && !input.value.trim()) {
            updateCountryComboboxFlag("");
          }
        }

        function setNewAddressCountry(alpha2, options) {
          var userSwitch = !options || !options.force;
          if (userSwitch && isNewAddressEditorLocked()) {
            return;
          }
          var normalized = normalizeCountryAlpha2(alpha2);
          if (!normalized) {
            return;
          }
          if (
            userSwitch &&
            normalized === newAddressSelectedCountryAlpha2
          ) {
            return;
          }

          var previousCountry = newAddressSelectedCountryAlpha2;
          var countryChanged =
            !!previousCountry &&
            normalized !== previousCountry;

          if (countryChanged && previousCountry) {
            rememberCurrentPickupPointsForCountry(previousCountry);
            captureNewAddressEditorStateForCountry(previousCountry);
          }

          newAddressSelectedCountryAlpha2 = normalized;
          syncCountryComboboxValue(normalized);
          var countryInput = getNewAddressCountryInput();
          if (countryInput) {
            countryInput.disabled = isNewAddressEditorLocked();
            if (!countryInput.disabled) {
              countryInput.placeholder = t("newAddressCountryPlaceholder");
            }
          }

          if (countryChanged || userSwitch) {
            newAddressPickupPointsLoadedCity = "";
            newAddressPickupPointsLoadingCity = "";
            newAddressPickupPoints = [];
            pendingPickupPointId = null;
            clearNewAddressPickupPointSelection();
            applyNewAddressCountryDraft(normalized);
          }

          if (newAddressMapInstance && window.google && window.google.maps) {
            centerNewAddressMapOnCountry(window.google.maps);
          }

          if (newAddressDeliveryType) {
            loadNewAddressCities({
              preserveSharedCity: true,
              restoreTypeDraft: countryChanged || userSwitch,
            });
          }
          updateContactPhoneField();
        }

        function loadNewAddressDestinationCountries() {
          var countryInput = getNewAddressCountryInput();
          if (!countryInput) {
            return;
          }
          var requestId = ++newAddressCountriesRequestId;
          setCountryComboboxState(true, t("countriesLoading"), "");

          api
            .getDestinationCountries()
            .then(function (countries) {
              if (requestId !== newAddressCountriesRequestId || newAddressModal.hidden) {
                return;
              }
              newAddressDestinationCountries = (Array.isArray(countries) ? countries : [])
                .map(function (code) {
                  return normalizeCountryAlpha2(code);
                })
                .filter(function (code) {
                  return !!code;
                });

              if (!newAddressDestinationCountries.length) {
                newAddressSelectedCountryAlpha2 = "";
                setCountryComboboxState(true, t("noCountriesAvailable"), "");
                updateContactPhoneField();
                if (newAddressEditorBootstrapActive) {
                  markNewAddressEditorCitiesReady();
                  updateNewAddressEditorInteractivity();
                }
                return;
              }

              var initialCountry = "";
              if (newAddressPendingPrefillCountryAlpha2) {
                var prefillCountry = normalizeCountryAlpha2(
                  newAddressPendingPrefillCountryAlpha2
                );
                if (newAddressDestinationCountries.indexOf(prefillCountry) !== -1) {
                  initialCountry = prefillCountry;
                }
              }
              if (!initialCountry) {
                initialCountry = newAddressDestinationCountries[0];
              }
              newAddressPendingPrefillCountryAlpha2 = "";
              setNewAddressCountry(initialCountry, { force: true });
              updateNewAddressEditorInteractivity();
            })
            .catch(function () {
              if (requestId !== newAddressCountriesRequestId || newAddressModal.hidden) {
                return;
              }
              newAddressDestinationCountries = [];
              newAddressSelectedCountryAlpha2 = "";
              setCountryComboboxState(true, t("countriesLoadFailed"), "");
              updateContactPhoneField();
              if (newAddressEditorBootstrapActive) {
                markNewAddressEditorCitiesReady();
                updateNewAddressEditorInteractivity();
              }
            });
        }

        function loadGoogleMaps(apiKey) {
          if (!apiKey) {
            return Promise.reject(new Error("missing_api_key"));
          }
          if (window.google && window.google.maps) {
            return Promise.resolve(window.google.maps);
          }
          if (newAddressMapsPromise) {
            return newAddressMapsPromise;
          }
          newAddressMapsPromise = new Promise(function (resolve, reject) {
            var finished = false;
            var resolveIfAvailable = function () {
              if (finished) {
                return false;
              }
              if (window.google && window.google.maps) {
                finished = true;
                resolve(window.google.maps);
                return true;
              }
              return false;
            };
            window.__filuetshipIndexMapsInit = function () {
              if (resolveIfAvailable()) {
                return;
              }
              finished = true;
              reject(new Error("maps_not_available"));
            };
            var script = document.createElement("script");
            script.src =
              "https://maps.googleapis.com/maps/api/js?key=" +
              encodeURIComponent(apiKey) +
              "&callback=__filuetshipIndexMapsInit";
            script.async = true;
            script.onload = function () {
              resolveIfAvailable();
            };
            script.onerror = function () {
              finished = true;
              reject(new Error("maps_load_failed"));
            };
            document.head.appendChild(script);
            setTimeout(function () {
              if (finished) {
                return;
              }
              if (resolveIfAvailable()) {
                return;
              }
              finished = true;
              reject(new Error("maps_load_timeout"));
            }, 15000);
          });
          return newAddressMapsPromise;
        }

        function ensureNewAddressMapInstance(maps) {
          if (newAddressMapInstance) {
            return newAddressMapInstance;
          }
          if (
            !newAddressMapContainer ||
            newAddressMapContainer.classList.contains("is-unavailable")
          ) {
            return null;
          }
          newAddressMapContainer.className = "new-address-modal__map";
          newAddressMapContainer.textContent = "";
          newAddressMapInstance = new maps.Map(newAddressMapContainer, {
            center: { lat: 56.8796, lng: 24.6032 },
            zoom: 4,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
          });
          return newAddressMapInstance;
        }

        function buildNewAddressGeocodeQuery(city, addressLine) {
          var resolvedCity = resolveSelectedCity(city) || String(city || "").trim();
          var line = String(addressLine || "").trim();
          var countryName = getCountryGeocodeName(getEditorCountryAlpha2());
          var parts = [];
          if (line) {
            parts.push(line);
          }
          if (resolvedCity) {
            parts.push(resolvedCity);
          }
          if (countryName) {
            parts.push(countryName);
          }
          return parts.join(", ");
        }

        function getPickupPointPostalCode(point) {
          if (!point) {
            return "";
          }
          var addr = point.address || {};
          var value =
            addr.postal_code ||
            addr.postalCode ||
            addr.zip ||
            addr.ZIP ||
            addr.postcode;
          return value ? String(value).trim() : "";
        }

        function extractPostalCodeFromGeocoderResult(result) {
          if (!result || !Array.isArray(result.address_components)) {
            return "";
          }
          for (var i = 0; i < result.address_components.length; i++) {
            var component = result.address_components[i];
            if (!component || !Array.isArray(component.types)) {
              continue;
            }
            if (component.types.indexOf("postal_code") !== -1) {
              return String(component.long_name || component.short_name || "").trim();
            }
          }
          return "";
        }

        function resetNewAddressPostalCodeState() {
          newAddressPostalCode = "";
          newAddressPostalCodePending = false;
          newAddressPostalCodeBeforeLookup = "";
          refreshNewAddressPostalCodeState();
        }

        function beginNewAddressPostalCodeLookup() {
          newAddressPostalCodeBeforeLookup = newAddressPostalCode;
          newAddressPostalCodePending = true;
          refreshNewAddressPostalCodeState();
        }

        function finishNewAddressPostalCodeLookup(postalCode) {
          var resolved = String(postalCode || "").trim();
          newAddressPostalCode =
            resolved || newAddressPostalCodeBeforeLookup || "";
          newAddressPostalCodeBeforeLookup = "";
          newAddressPostalCodePending = false;
          refreshNewAddressPostalCodeState();
        }

        function isNewAddressPostalCodeRequired() {
          if (!newAddressDeliveryType || newAddressModal.hidden) {
            return false;
          }
          if (isPickupDeliveryMode(newAddressDeliveryType)) {
            return Boolean(resolveSelectedPickupPoint());
          }
          var addressInput = newAddressForm.querySelector('[name="address"]');
          return Boolean(addressInput && addressInput.value.trim());
        }

        function isNewAddressPostalCodeBlocking() {
          if (!isNewAddressPostalCodeRequired()) {
            return false;
          }
          if (newAddressPostalCodePending) {
            return true;
          }
          return !newAddressPostalCode;
        }

        function updateNewAddressPostalCodeUi() {
          if (newAddressPostalCodeError) {
            if (isNewAddressPostalCodeBlocking() && !newAddressPostalCodePending) {
              newAddressPostalCodeError.hidden = false;
              newAddressPostalCodeError.textContent = t("newAddressPostalCodeUndetermined");
            } else {
              newAddressPostalCodeError.hidden = true;
              newAddressPostalCodeError.textContent = "";
            }
          }
        }

        function syncNewAddressSaveButtonState() {
          if (!newAddressModal || newAddressModal.hidden) {
            return;
          }
          var locked = isNewAddressEditorLocked();
          newAddressModalSave.disabled =
            locked || newAddressSaving || isNewAddressPostalCodeBlocking();
        }

        function refreshNewAddressPostalCodeState() {
          updateNewAddressPostalCodeUi();
          syncNewAddressSaveButtonState();
        }

        function resolveNewAddressPostalCodeForSave() {
          if (isPickupDeliveryMode(newAddressDeliveryType)) {
            var point = resolveSelectedPickupPoint();
            return getPickupPointPostalCode(point) || newAddressPostalCode;
          }
          return newAddressPostalCode;
        }

        function applyPostalCodeFromGeocoderResult(result) {
          finishNewAddressPostalCodeLookup(extractPostalCodeFromGeocoderResult(result));
        }

        function resolvePickupPointPostalCodeFromMaps(point, maps, location, callback) {
          var fromPoint = getPickupPointPostalCode(point);
          if (fromPoint) {
            callback(fromPoint);
            return;
          }
          if (!maps || !maps.Geocoder) {
            callback("");
            return;
          }
          var geocoder = new maps.Geocoder();
          var alpha2 = getEditorCountryAlpha2Lower();
          var request = location
            ? { location: location }
            : {
                address:
                  getPickupPointLabel(point) +
                  (getCountryGeocodeName(getEditorCountryAlpha2())
                    ? ", " + getCountryGeocodeName(getEditorCountryAlpha2())
                    : ""),
              };
          if (!location && alpha2) {
            request.componentRestrictions = { country: alpha2 };
          }
          geocoder.geocode(request, function (results, status) {
            if (status !== "OK" || !results || !results.length) {
              callback("");
              return;
            }
            callback(extractPostalCodeFromGeocoderResult(results[0]));
          });
        }

        function clearNewAddressMapMarkers() {
          newAddressMapMarkers.forEach(function (marker) {
            marker.setMap(null);
          });
          newAddressMapMarkers = [];
          newAddressCityMarker = null;
        }

        function addNewAddressMapMarker(maps, position, title, pickupPoint) {
          if (!newAddressMapInstance) {
            return null;
          }
          var marker = new maps.Marker({
            map: newAddressMapInstance,
            position: position,
            title: title || "",
          });
          if (pickupPoint) {
            marker.addListener("click", function () {
              selectPickupPointOption(pickupPoint);
            });
          }
          newAddressMapMarkers.push(marker);
          return marker;
        }

        function getPickupPointPosition(point) {
          var addr = point && point.address;
          if (!addr) {
            return null;
          }
          var lat = addr.lat != null ? addr.lat : addr.latitude;
          var lng = addr.lng != null ? addr.lng : addr.longitude;
          if (
            lat == null &&
            Array.isArray(addr.latLong) &&
            addr.latLong.length >= 2
          ) {
            lat = addr.latLong[0];
            lng = addr.latLong[1];
          }
          if (lat != null && lng != null && !isNaN(Number(lat)) && !isNaN(Number(lng))) {
            return { lat: Number(lat), lng: Number(lng) };
          }
          return null;
        }

        function collectNewAddressMapMarkerPositions() {
          return newAddressMapMarkers
            .map(function (marker) {
              var position = marker.getPosition();
              if (!position) {
                return null;
              }
              return { lat: position.lat(), lng: position.lng() };
            })
            .filter(function (position) {
              return !!position;
            });
        }

        function fitNewAddressMapToPositions(positions) {
          if (!newAddressMapInstance || !positions.length || !window.google || !window.google.maps) {
            return;
          }
          if (positions.length === 1) {
            newAddressMapInstance.setCenter(positions[0]);
            newAddressMapInstance.setZoom(14);
            return;
          }
          var bounds = new window.google.maps.LatLngBounds();
          positions.forEach(function (position) {
            bounds.extend(position);
          });
          newAddressMapInstance.fitBounds(bounds);
        }

        function focusNewAddressMapOnCityOnly(city) {
          var resolvedCity = resolveSelectedCity(city) || String(city || "").trim();
          if (!resolvedCity) {
            return;
          }
          focusNewAddressMapOnLocation(resolvedCity, "");
        }

        function showAllPickupPointsOnMap(points) {
          if (!points || !points.length || newAddressModal.hidden) {
            return;
          }
          var apiKey = (cfg.googleMapsApiKey || "").trim();
          if (!apiKey) {
            return;
          }
          loadGoogleMaps(apiKey)
            .then(function (maps) {
              if (newAddressModal.hidden || !ensureNewAddressMapInstance(maps)) {
                return;
              }
              window.google.maps.event.trigger(newAddressMapInstance, "resize");
              var requestId = ++newAddressMapGeocodeRequestId;
              clearNewAddressMapMarkers();
              var toGeocode = [];
              points.forEach(function (point) {
                var position = getPickupPointPosition(point);
                if (position) {
                  addNewAddressMapMarker(
                    maps,
                    position,
                    getPickupPointLabel(point),
                    point
                  );
                } else {
                  toGeocode.push(point);
                }
              });
              var positions = collectNewAddressMapMarkerPositions();
              if (positions.length) {
                fitNewAddressMapToPositions(positions);
              }
              if (!toGeocode.length) {
                if (!positions.length) {
                  var cityInput = getNewAddressCityInput();
                  focusNewAddressMapOnCityOnly(
                    cityInput ? cityInput.value : ""
                  );
                }
                return;
              }
              var alpha2 = getEditorCountryAlpha2Lower();
              var countryName = getCountryGeocodeName(getEditorCountryAlpha2());
              var geocoder = new maps.Geocoder();
              var pending = toGeocode.length;
              toGeocode.forEach(function (point) {
                var geocodeRequest = {
                  address:
                    getPickupPointLabel(point) +
                    (countryName ? ", " + countryName : ""),
                };
                if (alpha2) {
                  geocodeRequest.componentRestrictions = { country: alpha2 };
                }
                geocoder.geocode(geocodeRequest, function (results, status) {
                  if (
                    requestId !== newAddressMapGeocodeRequestId ||
                    !newAddressMapInstance
                  ) {
                    return;
                  }
                  pending -= 1;
                  if (status === "OK" && results && results.length) {
                    var location = results[0].geometry.location;
                    addNewAddressMapMarker(
                      maps,
                      location,
                      getPickupPointLabel(point),
                      point
                    );
                  }
                  if (pending === 0) {
                    var markerPositions = collectNewAddressMapMarkerPositions();
                    if (markerPositions.length) {
                      fitNewAddressMapToPositions(markerPositions);
                      return;
                    }
                    var cityInput = getNewAddressCityInput();
                    focusNewAddressMapOnCityOnly(
                      cityInput ? cityInput.value : ""
                    );
                  }
                });
              });
            })
            .catch(function () {
              // ignore map focus errors
            });
        }

        function focusNewAddressMapOnLocation(city, addressLine) {
          var query = buildNewAddressGeocodeQuery(city, addressLine);
          if (!query || newAddressModal.hidden) {
            return;
          }
          var hasStreetAddress = Boolean(String(addressLine || "").trim());
          if (hasStreetAddress && !isPickupDeliveryMode(newAddressDeliveryType)) {
            beginNewAddressPostalCodeLookup();
          }
          var apiKey = (cfg.googleMapsApiKey || "").trim();
          if (!apiKey) {
            if (hasStreetAddress && !isPickupDeliveryMode(newAddressDeliveryType)) {
              finishNewAddressPostalCodeLookup("");
            }
            return;
          }
          loadGoogleMaps(apiKey)
            .then(function (maps) {
              if (newAddressModal.hidden) {
                return;
              }
              if (!ensureNewAddressMapInstance(maps)) {
                if (hasStreetAddress && !isPickupDeliveryMode(newAddressDeliveryType)) {
                  finishNewAddressPostalCodeLookup("");
                }
                return;
              }
              window.google.maps.event.trigger(newAddressMapInstance, "resize");
              var alpha2 = getEditorCountryAlpha2Lower();
              var requestId = ++newAddressMapGeocodeRequestId;
              var geocoder = new maps.Geocoder();
              var geocodeRequest = {
                address: query,
              };
              if (alpha2) {
                geocodeRequest.componentRestrictions = { country: alpha2 };
              }
              geocoder.geocode(geocodeRequest, function (results, status) {
                if (
                  requestId !== newAddressMapGeocodeRequestId ||
                  !newAddressMapInstance
                ) {
                  return;
                }
                if (status !== "OK" || !results || !results.length) {
                  if (hasStreetAddress && !isPickupDeliveryMode(newAddressDeliveryType)) {
                    finishNewAddressPostalCodeLookup("");
                  }
                  return;
                }
                var geometry = results[0].geometry;
                var location = geometry.location;
                if (!hasStreetAddress && geometry.viewport) {
                  newAddressMapInstance.fitBounds(geometry.viewport);
                } else {
                  newAddressMapInstance.setCenter(location);
                  newAddressMapInstance.setZoom(hasStreetAddress ? 16 : 11);
                }
                clearNewAddressMapMarkers();
                newAddressCityMarker = addNewAddressMapMarker(maps, location, "");
                if (hasStreetAddress && !isPickupDeliveryMode(newAddressDeliveryType)) {
                  applyPostalCodeFromGeocoderResult(results[0]);
                }
              });
            })
            .catch(function () {
              if (hasStreetAddress && !isPickupDeliveryMode(newAddressDeliveryType)) {
                finishNewAddressPostalCodeLookup("");
              }
            });
        }

        function focusNewAddressMapOnCity(city) {
          var addressInput = newAddressForm.querySelector('[name="address"]');
          focusNewAddressMapOnLocation(
            city,
            addressInput ? addressInput.value.trim() : ""
          );
        }

        function focusNewAddressMapOnAddressField() {
          if (isPickupDeliveryMode(newAddressDeliveryType)) {
            return;
          }
          var cityInput = getNewAddressCityInput();
          var addressInput = newAddressForm.querySelector('[name="address"]');
          focusNewAddressMapOnLocation(
            cityInput ? cityInput.value : "",
            addressInput ? addressInput.value.trim() : ""
          );
        }

        function centerNewAddressMapOnCountry(maps) {
          if (!newAddressMapInstance) {
            return;
          }
          var alpha2 = getEditorCountryAlpha2();
          var preset = alpha2 && COUNTRY_MAP_VIEW[alpha2];
          if (preset) {
            newAddressMapInstance.setCenter({ lat: preset.lat, lng: preset.lng });
            newAddressMapInstance.setZoom(preset.zoom);
            return;
          }
          if (!alpha2 || !maps || !maps.Geocoder) {
            newAddressMapInstance.setCenter({ lat: 56.8796, lng: 24.6032 });
            newAddressMapInstance.setZoom(4);
            return;
          }
          var geocoder = new maps.Geocoder();
          geocoder.geocode(
            { address: getCountryGeocodeName(alpha2) },
            function (results, status) {
              if (
                status !== "OK" ||
                !results ||
                !results.length ||
                !newAddressMapInstance
              ) {
                newAddressMapInstance.setCenter({ lat: 56.8796, lng: 24.6032 });
                newAddressMapInstance.setZoom(4);
                return;
              }
              var geometry = results[0].geometry;
              if (geometry.viewport) {
                newAddressMapInstance.fitBounds(geometry.viewport);
                return;
              }
              if (geometry.location) {
                newAddressMapInstance.setCenter(geometry.location);
                newAddressMapInstance.setZoom(6);
              }
            }
          );
        }

        function refreshNewAddressMapLayout() {
          if (!newAddressMapInstance || !window.google || !window.google.maps) {
            return;
          }
          window.google.maps.event.trigger(newAddressMapInstance, "resize");
          centerNewAddressMapOnCountry(window.google.maps);
        }

        function showNewAddressMapUnavailable(message) {
          if (!newAddressMapContainer) {
            return;
          }
          newAddressMapInstance = null;
          clearNewAddressMapMarkers();
          newAddressMapContainer.className = "new-address-modal__map is-unavailable";
          newAddressMapContainer.textContent = message;
        }

        function refreshNewAddressMapFocus() {
          if (newAddressModal.hidden) {
            return;
          }
          if (isPickupDeliveryMode(newAddressDeliveryType)) {
            var pickupPoint = resolveSelectedPickupPoint();
            if (pickupPoint) {
              focusNewAddressMapOnPickupPoint(pickupPoint);
              return;
            }
            var cityInput = getNewAddressCityInput();
            var city = cityInput ? resolveSelectedCity(cityInput.value) : "";
            if (city && newAddressPickupPoints.length) {
              showAllPickupPointsOnMap(newAddressPickupPoints);
              return;
            }
            if (city) {
              focusNewAddressMapOnCityOnly(city);
              return;
            }
            refreshNewAddressMapLayout();
            return;
          }
          var cityInput = getNewAddressCityInput();
          var addressInput = newAddressForm.querySelector('[name="address"]');
          var city = cityInput
            ? resolveSelectedCity(cityInput.value) || cityInput.value.trim()
            : "";
          var addressLine = addressInput ? addressInput.value.trim() : "";
          if (city || addressLine) {
            focusNewAddressMapOnLocation(city, addressLine);
            return;
          }
          refreshNewAddressMapLayout();
        }

        function initNewAddressMap() {
          if (!newAddressMapContainer) {
            return;
          }
          var apiKey = (cfg.googleMapsApiKey || "").trim();
          if (!apiKey) {
            showNewAddressMapUnavailable(t("mapRequiresKey"));
            return;
          }
          if (newAddressMapInstance) {
            newAddressMapContainer.className = "new-address-modal__map";
            window.setTimeout(function () {
              if (newAddressModal.hidden) {
                return;
              }
              refreshNewAddressMapLayout();
              refreshNewAddressMapFocus();
            }, 50);
            return;
          }
          newAddressMapContainer.className = "new-address-modal__map";
          newAddressMapContainer.textContent = "";
          loadGoogleMaps(apiKey)
            .then(function (maps) {
              if (newAddressModal.hidden) {
                return;
              }
              if (!ensureNewAddressMapInstance(maps)) {
                return;
              }
              window.setTimeout(function () {
                if (newAddressModal.hidden) {
                  return;
                }
                refreshNewAddressMapLayout();
                refreshNewAddressMapFocus();
              }, 50);
            })
            .catch(function () {
              showNewAddressMapUnavailable(t("mapRequiresKey"));
            });
        }

        function normalizeLocale(value) {
          var raw = String(value || "").trim().toLowerCase();
          if (!raw) {
            return null;
          }
          var base = raw.split("-")[0];
          if (base === "en" || base === "ru") {
            return base;
          }
          return null;
        }

        function readLocaleFromUrl() {
          try {
            var params = new URLSearchParams(window.location.search || "");
            return normalizeLocale(params.get("lang") || params.get("locale"));
          } catch (e) {
            return null;
          }
        }

        function readCalculationPayloadIdFromUrl() {
          try {
            var params = new URLSearchParams(window.location.search || "");
            return (
              params.get("id") ||
              params.get("calculation_payload_id") ||
              params.get("calculationPayloadId") ||
              params.get("calculation_payload") ||
              ""
            ).trim();
          } catch (e) {
            return "";
          }
        }

        function isShipmentConfirmationMode() {
          return widgetMode === "shipment-confirmation";
        }

        function readCustomerId() {
          try {
            var params = new URLSearchParams(window.location.search || "");
            return (
              (params.get("customer_id") || params.get("customerId") || "").trim() ||
              (cfg.customerId || "").trim()
            );
          } catch (e) {
            return (cfg.customerId || "").trim();
          }
        }

        function resolveLocale() {
          return (
            readLocaleFromUrl() ||
            normalizeLocale(cfg.locale) ||
            "en"
          );
        }

        function applyCalculationPayloadToConfig(payload) {
          if (!payload || typeof payload !== "object") {
            return;
          }
          if (payload.company_id != null && String(payload.company_id).trim()) {
            cfg.companyId = String(payload.company_id).trim();
          }
          if (payload.customer_id != null && String(payload.customer_id).trim()) {
            cfg.customerId = String(payload.customer_id).trim();
          }
          if (payload.language != null && String(payload.language).trim()) {
            cfg.locale = normalizeLocale(payload.language) || String(payload.language).trim();
          }
          if (payload.environment != null && String(payload.environment).trim()) {
            cfg.environment = String(payload.environment).trim();
          }
          if (payload.data && typeof payload.data === "object") {
            cfg.calculationPayloadData = payload.data;
          }
          window.FILUETSHIP_WIDGET_CONFIG = cfg;
          locale = resolveLocale();
        }

        function showWidgetErrorPopup(message) {
          if (!widgetErrorPopup || !widgetErrorPopupMessage) {
            return;
          }
          widgetErrorPopupMessage.textContent = message || "";
          widgetErrorPopup.hidden = false;
        }

        function handleCalculationPayloadConfirmedState(payload) {
          calculationPayloadConfirmed = !!(
            payload && payload.confirmed_by_customer === true
          );
          if (calculationPayloadConfirmed) {
            showWidgetErrorPopup(t("calculationPayloadAlreadyConfirmed"));
            suppressShippingRatesForConfirmedPayload();
            return;
          }
          updateShippingRatesConfirmButton();
        }

        var locale = resolveLocale();

        function t(key) {
          var copy = I18N[locale] || I18N.en;
          return copy[key] || I18N.en[key] || key;
        }

        function matchesDeliveryType(addressType, deliveryType) {
          if (String(addressType) === String(deliveryType)) {
            return true;
          }
          if (translations.normalizeDeliveryTypeKey) {
            return (
              translations.normalizeDeliveryTypeKey(addressType) ===
              translations.normalizeDeliveryTypeKey(deliveryType)
            );
          }
          return String(addressType).toLowerCase() === String(deliveryType).toLowerCase();
        }

        function parseAddressUpdatedAt(address) {
          if (!address || address.updated_at == null) {
            return 0;
          }
          var timestamp = Date.parse(String(address.updated_at));
          return Number.isFinite(timestamp) ? timestamp : 0;
        }

        function pickLatestAddress(addresses) {
          if (!addresses.length) {
            return null;
          }
          return addresses.reduce(function (latest, address) {
            if (!latest) {
              return address;
            }
            var latestTs = parseAddressUpdatedAt(latest);
            var addressTs = parseAddressUpdatedAt(address);
            if (addressTs > latestTs) {
              return address;
            }
            if (addressTs < latestTs) {
              return latest;
            }
            return Number(address.id || 0) > Number(latest.id || 0) ? address : latest;
          }, null);
        }

        function findAddressesForType(deliveryType) {
          var matchedType =
            resolveMatchingTypeOption(deliveryType, loadedTypes) || deliveryType;
          if (!matchedType) {
            return [];
          }
          return loadedAddresses.filter(function (address) {
            return address && matchesDeliveryType(address.delivery_type, matchedType);
          });
        }

        function findLatestAddressForType(deliveryType) {
          return pickLatestAddress(findAddressesForType(deliveryType));
        }

        function normalizeLoadedAddressesActiveState() {
          var activeAddresses = loadedAddresses.filter(function (address) {
            return address && address.is_active;
          });
          if (activeAddresses.length <= 1) {
            return;
          }
          var keepActive = pickLatestAddress(activeAddresses);
          if (!keepActive) {
            return;
          }
          loadedAddresses = loadedAddresses.map(function (address) {
            if (!address) {
              return address;
            }
            return Object.assign({}, address, {
              is_active: address.id === keepActive.id,
            });
          });
        }

        function findAnyActiveAddress() {
          return (
            loadedAddresses.find(function (address) {
              return address && address.is_active;
            }) || null
          );
        }

        function isDeliverySelectionReady() {
          return (
            deliveryTypesLoadState === "ready" &&
            addressLoadState === "ready" &&
            !!selectedType
          );
        }

        function resolveConfiguredDefaultDeliveryType(types) {
          var configuredDefault = String(cfg.defaultDeliveryType || "").trim();
          if (!configuredDefault || !types.length) {
            return null;
          }
          return resolveMatchingTypeOption(configuredDefault, types);
        }

        function resolveInitialDeliveryType(types) {
          if (!types.length) {
            return null;
          }
          var activeAddress = findAnyActiveAddress();
          if (activeAddress) {
            return resolveMatchingTypeOption(activeAddress.delivery_type, types);
          }
          return resolveConfiguredDefaultDeliveryType(types) || types[0];
        }

        function syncSelectedTypeWithActiveAddress() {
          if (!loadedTypes.length || addressLoadState !== "ready") {
            return false;
          }
          var activeAddress = findAnyActiveAddress();
          if (!activeAddress) {
            return false;
          }
          var matchedType = resolveMatchingTypeOption(
            activeAddress.delivery_type,
            loadedTypes
          );
          if (!matchedType || matchedType === selectedType) {
            return false;
          }
          setActiveButton(matchedType, { skipAddressSync: true });
          return true;
        }

        function setSelectedDeliveryType(type) {
          if (selectedType === type) {
            return false;
          }
          selectedType = type;
          if (!row) {
            return true;
          }
          row.querySelectorAll(".delivery-type-btn").forEach(function (btn) {
            var isActive = btn.getAttribute("data-type") === type;
            btn.classList.toggle("is-active", isActive);
            btn.setAttribute("aria-pressed", isActive ? "true" : "false");
          });
          return true;
        }

        function syncAddressListActiveState(listRoot) {
          if (!listRoot) {
            return;
          }
          listRoot.querySelectorAll(".address-modal__item").forEach(function (node) {
            var id = Number(node.getAttribute("data-address-id"));
            var address = findAddressById(id);
            var isActive = !!(address && address.is_active);
            node.classList.toggle("is-selected", isActive);
            node.setAttribute("aria-pressed", isActive ? "true" : "false");
            var radio = node.querySelector(".address-modal__item-radio");
            if (radio) {
              radio.checked = isActive;
            }
          });
        }

        function applyActiveAddressState(addressId, deliveryType) {
          var activatedAddress = findAddressById(addressId);
          var typeKey =
            (activatedAddress &&
              resolveMatchingTypeOption(activatedAddress.delivery_type, loadedTypes)) ||
            deliveryType;
          loadedAddresses = loadedAddresses.map(function (address) {
            if (address.id === addressId) {
              return Object.assign({}, address, {
                is_active: true,
                delivery_type: typeKey || address.delivery_type,
                updated_at: new Date().toISOString(),
              });
            }
            if (address.id !== addressId && address.is_active) {
              return Object.assign({}, address, { is_active: false });
            }
            return address;
          });
        }

        function mergeUpdatedActiveAddress(updated) {
          if (!updated) {
            return;
          }
          var index = loadedAddresses.findIndex(function (address) {
            return address.id === updated.id;
          });
          if (index === -1) {
            loadedAddresses.push(updated);
          } else {
            loadedAddresses[index] = updated;
          }
          loadedAddresses = loadedAddresses.map(function (address) {
            if (address.id !== updated.id && address.is_active) {
              return Object.assign({}, address, { is_active: false });
            }
            return address;
          });
        }

        function activateDeliveryAddress(addressId, deliveryType, options) {
          options = options || {};
          var matchedType =
            resolveMatchingTypeOption(deliveryType, loadedTypes) || deliveryType;
          if (!addressId || !matchedType) {
            return Promise.resolve();
          }

          var activationId = ++addressActivationSequence;

          if (!options.skipTypeChange && matchedType !== selectedType) {
            setSelectedDeliveryType(matchedType);
          }

          applyActiveAddressState(addressId, matchedType);
          modalSelectedAddressId = addressId;

          if (options.closeModal) {
            closeAddressModal();
          }
          renderAddressUi();

          var patchPayload = { is_active: true };
          if (!options.activateOnly) {
            patchPayload.delivery_type = matchedType;
          }

          return api
            .updateDeliveryAddress(addressId, patchPayload)
            .then(function (updated) {
              if (activationId !== addressActivationSequence) {
                return;
              }
              if (updated) {
                mergeUpdatedActiveAddress(updated);
                renderAddressUi();
              }
            })
            .catch(function (err) {
              if (activationId !== addressActivationSequence) {
                return;
              }
              if (!options.silentError) {
                window.alert(t("addressConfirmFailed"));
              }
              if (options.rethrowOnError) {
                throw err || new Error("address_confirm_failed");
              }
            });
        }

        function handleDeliveryTypeChange(type) {
          var matchedType = resolveMatchingTypeOption(type, loadedTypes) || type;
          if (!matchedType) {
            renderAddressUi();
            return Promise.resolve();
          }

          var latestAddress = findLatestAddressForType(matchedType);
          if (!latestAddress) {
            renderAddressUi();
            return Promise.resolve();
          }

          var addressType =
            resolveMatchingTypeOption(latestAddress.delivery_type, loadedTypes) ||
            latestAddress.delivery_type ||
            matchedType;

          return activateDeliveryAddress(latestAddress.id, addressType, {
            skipTypeChange: true,
            activateOnly: true,
          });
        }

        function findActiveAddress() {
          var active = findAnyActiveAddress();
          if (!active || !selectedType) {
            return active;
          }
          var matchedType =
            resolveMatchingTypeOption(selectedType, loadedTypes) || selectedType;
          if (matchesDeliveryType(active.delivery_type, matchedType)) {
            return active;
          }
          return null;
        }

        function sortAddressesByIdDesc(addresses) {
          return addresses.slice().sort(function (a, b) {
            return Number(b.id || 0) - Number(a.id || 0);
          });
        }

        function formatContactDisplayName(contactInfo) {
          if (!contactInfo || typeof contactInfo !== "object") {
            return "";
          }
          var firstName = String(contactInfo.first_name || "").trim();
          var lastName = String(contactInfo.last_name || "").trim();
          var combined = (firstName + " " + lastName).trim();
          if (combined) {
            return combined;
          }
          return String(contactInfo.name || "").trim();
        }

        function splitLegacyContactName(name) {
          var trimmed = String(name || "").trim();
          if (!trimmed) {
            return { firstName: "", lastName: "" };
          }
          var spaceIndex = trimmed.indexOf(" ");
          if (spaceIndex === -1) {
            return { firstName: trimmed, lastName: "" };
          }
          return {
            firstName: trimmed.slice(0, spaceIndex).trim(),
            lastName: trimmed.slice(spaceIndex + 1).trim(),
          };
        }

        function formatContactInfo(contactInfo) {
          if (!contactInfo || typeof contactInfo !== "object") {
            return "";
          }
          var parts = [];
          var name = formatContactDisplayName(contactInfo);
          if (name) {
            parts.push(name);
          }
          if (contactInfo.email) {
            parts.push(String(contactInfo.email));
          }
          if (contactInfo.phone) {
            parts.push(String(contactInfo.phone));
          }
          return parts.join(" · ");
        }

        function createAddressLineWithProviderIcon(
          addressText,
          providerCode,
          lineClassName,
          rowClassName
        ) {
          var row = document.createElement("div");
          row.className = rowClassName;
          var icon = createProviderIconElement(providerCode);
          if (icon) {
            row.appendChild(icon);
          }
          var line = document.createElement("p");
          line.className = lineClassName;
          line.textContent = addressText || "—";
          row.appendChild(line);
          return row;
        }

        function renderAddressCardContent(address) {
          var contact = formatContactInfo(address.contact_info);
          addressCard.className = "delivery-address-card delivery-address-card--active";
          addressCard.innerHTML = "";

          var body = document.createElement("div");
          body.className = "delivery-address-card__body";

          var city = document.createElement("p");
          city.className = "delivery-address-card__city";
          city.textContent = address.city || "—";
          body.appendChild(city);

          body.appendChild(
            createAddressLineWithProviderIcon(
              address.address,
              address.provider_code,
              "delivery-address-card__line",
              "delivery-address-card__line-row"
            )
          );

          var contactRow = document.createElement("div");
          contactRow.className = "delivery-address-card__contact-row";

          var typeRow = document.createElement("span");
          typeRow.className = "delivery-address-card__type-row";
          typeRow.appendChild(createDeliveryTypeIconElement(address.delivery_type));

          if (contact) {
            var contactText = document.createElement("span");
            contactText.className = "delivery-address-card__contact";
            contactText.textContent = contact;
            contactRow.appendChild(contactText);
          }

          var typeLabel = document.createElement("span");
          typeLabel.className = "delivery-address-card__type";
          typeLabel.textContent = labelForType(address.delivery_type);
          typeRow.appendChild(typeLabel);
          contactRow.appendChild(typeRow);

          body.appendChild(contactRow);

          addressCard.appendChild(body);
          addressCard.appendChild(createAddressItemMenu(address));
        }

        function renderActiveAddressCard() {
          if (!addressCard) {
            return;
          }

          if (
            addressLoadState === "loading" ||
            deliveryTypesLoadState === "loading" ||
            (addressLoadState === "ready" && !selectedType)
          ) {
            addressCard.className = "delivery-address-card is-loading";
            addressCard.textContent = t("addressLoading");
            if (deliveryAddressEdit) {
              deliveryAddressEdit.hidden = true;
            }
            return;
          }

          if (addressLoadState === "no-customer") {
            addressCard.className = "delivery-address-card is-empty";
            addressCard.textContent = t("noCustomerId");
            if (deliveryAddressEdit) {
              deliveryAddressEdit.hidden = true;
            }
            return;
          }

          if (addressLoadState === "error") {
            addressCard.className = "delivery-address-card is-error";
            addressCard.textContent = t("addressLoadFailed");
            if (deliveryAddressEdit) {
              deliveryAddressEdit.hidden = true;
            }
            return;
          }

          if (deliveryAddressEdit) {
            deliveryAddressEdit.hidden = false;
          }

          var activeAddress = findActiveAddress();
          if (!activeAddress) {
            addressCard.className = "delivery-address-card is-empty";
            addressCard.textContent = t("noActiveAddress");
            maybeAutoOpenAddressModal();
            return;
          }

          modalAutoOpenedForType = null;
          renderAddressCardContent(activeAddress);
        }

        function buildAddressSearchText(address) {
          if (!address) {
            return "";
          }
          var parts = [
            address.city,
            address.address,
            address.postal_code,
            address.delivery_type,
            labelForType(address.delivery_type),
            address.provider_code,
          ];
          var contact = address.contact_info;
          if (contact && typeof contact === "object") {
            parts.push(
              contact.first_name,
              contact.last_name,
              contact.name,
              contact.email,
              contact.phone
            );
          }
          return parts
            .filter(function (part) {
              return part != null && String(part).trim();
            })
            .join(" ")
            .toLowerCase();
        }

        function addressMatchesFilter(address, query) {
          var normalized = String(query || "").trim().toLowerCase();
          if (!normalized) {
            return true;
          }
          var haystack = buildAddressSearchText(address);
          var terms = normalized.split(/\s+/).filter(Boolean);
          return terms.every(function (term) {
            return haystack.indexOf(term) !== -1;
          });
        }

        function getAddressModalFilterQuery() {
          if (!addressModalFilter) {
            return "";
          }
          return addressModalFilter.value.trim();
        }

        function resetAddressModalFilter() {
          if (addressModalFilter) {
            addressModalFilter.value = "";
          }
        }

        function renderAddressModalList() {
          if (!addressModalList || !addressModalAdd) {
            return;
          }

          addressModalList.innerHTML = "";
          addressModalError.hidden = true;
          addressModalError.textContent = "";
          openAddressMenuId = null;

          if (
            addressLoadState === "loading" ||
            deliveryTypesLoadState === "loading" ||
            (addressLoadState === "ready" && !selectedType)
          ) {
            addressModalAdd.hidden = true;
            var loadingNode = document.createElement("p");
            loadingNode.className = "delivery-address-list__empty";
            loadingNode.textContent = t("addressLoading");
            addressModalList.appendChild(loadingNode);
            return;
          }

          if (addressLoadState === "no-customer") {
            addressModalAdd.hidden = true;
            var noCustomerNode = document.createElement("p");
            noCustomerNode.className = "delivery-address-list__empty";
            noCustomerNode.textContent = t("noCustomerId");
            addressModalList.appendChild(noCustomerNode);
            return;
          }

          if (addressLoadState === "error") {
            addressModalAdd.hidden = true;
            var listErrorNode = document.createElement("p");
            listErrorNode.className = "delivery-address-list__error";
            listErrorNode.textContent = t("addressLoadFailed");
            addressModalList.appendChild(listErrorNode);
            return;
          }

          var shouldShowFilter = loadedAddresses.length > 4;
          if (addressModalFilterWrap) {
            addressModalFilterWrap.hidden = !shouldShowFilter;
          }
          if (!shouldShowFilter) {
            resetAddressModalFilter();
          }

          var filterQuery = shouldShowFilter ? getAddressModalFilterQuery() : "";
          var addresses = sortAddressesByIdDesc(loadedAddresses).filter(function (address) {
            return addressMatchesFilter(address, filterQuery);
          });

          if (!loadedAddresses.length) {
            addressModalAdd.hidden = false;
            var empty = document.createElement("p");
            empty.className = "address-modal__empty";
            empty.textContent = t("noAddressesAvailable");
            addressModalList.appendChild(empty);
            return;
          }

          if (!addresses.length) {
            addressModalAdd.hidden = false;
            var noMatches = document.createElement("p");
            noMatches.className = "address-modal__empty";
            noMatches.textContent = t("addressFilterNoResults");
            addressModalList.appendChild(noMatches);
            return;
          }

          addressModalAdd.hidden = false;

          addresses.forEach(function (address) {
            addressModalList.appendChild(
              createAddressListItem(address, {
                radioName: "delivery-address-selection",
                onSelect: function (addressId) {
                  var selectedAddress = findAddressById(addressId);
                  if (!selectedAddress) {
                    return;
                  }
                  var deliveryType =
                    resolveMatchingTypeOption(
                      selectedAddress.delivery_type,
                      loadedTypes
                    ) || selectedAddress.delivery_type;
                  activateDeliveryAddress(addressId, deliveryType);
                },
              })
            );
          });

          syncAddressListActiveState(addressModalList);
        }

        function renderAddressUi() {
          renderActiveAddressCard();
          if (!addressModal.hidden) {
            renderAddressModalList();
          }
          maybeLoadShippingRates();
        }

        var CURRENCY_SYMBOL_SUFFIX = {
          RUB: true,
        };

        function formatRateAmount(amount, currency) {
          var value = Number(amount);
          if (!Number.isFinite(value)) {
            return "—";
          }
          var code = String(currency || "").trim().toUpperCase();
          if (!code) {
            return value.toFixed(2);
          }
          var intlLocale = locale === "ru" ? "ru-RU" : "en-US";
          try {
            var formatter = new Intl.NumberFormat(intlLocale, {
              style: "currency",
              currency: code,
              currencyDisplay: "narrowSymbol",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            var parts = formatter.formatToParts(value);
            var symbol = "";
            var number = "";
            parts.forEach(function (part) {
              if (part.type === "currency") {
                symbol = part.value;
              } else {
                number += part.value;
              }
            });
            number = number.trim();
            if (!symbol) {
              return formatter.format(value);
            }
            if (CURRENCY_SYMBOL_SUFFIX[code]) {
              return number + "\u00A0" + symbol;
            }
            return symbol + number;
          } catch (e) {
            return value.toFixed(2);
          }
        }

        function formatRateDeliveryDays(rate) {
          var min = rate && rate.delivery_days_min;
          var max = rate && rate.delivery_days_max;
          if (min != null && max != null && Number(min) !== Number(max)) {
            return t("rateDeliveryDaysRange")
              .replace("{{min}}", String(min))
              .replace("{{max}}", String(max));
          }
          var days = max != null ? max : min;
          if (days == null) {
            return "";
          }
          return t("rateDeliveryDaysSingle").replace("{{days}}", String(days));
        }

        function getRatesCarouselMaxOffset() {
          return Math.max(0, loadedRates.length - RATES_CAROUSEL_VISIBLE_COUNT);
        }

        function clampRatesCarouselOffset() {
          var maxOffset = getRatesCarouselMaxOffset();
          if (ratesCarouselOffset < 0) {
            ratesCarouselOffset = 0;
          } else if (ratesCarouselOffset > maxOffset) {
            ratesCarouselOffset = maxOffset;
          }
        }

        function ensureSelectedRateVisible() {
          if (loadedRates.length <= RATES_CAROUSEL_VISIBLE_COUNT) {
            return;
          }
          clampRatesCarouselOffset();
          if (selectedRateIndex < ratesCarouselOffset) {
            ratesCarouselOffset = selectedRateIndex;
          } else if (selectedRateIndex >= ratesCarouselOffset + RATES_CAROUSEL_VISIBLE_COUNT) {
            ratesCarouselOffset = selectedRateIndex - RATES_CAROUSEL_VISIBLE_COUNT + 1;
          }
          clampRatesCarouselOffset();
        }

        function updateShippingRateCardSelection(row) {
          row.querySelectorAll(".shipping-rates-card").forEach(function (btn, btnIndex) {
            var isSelected = btnIndex === selectedRateIndex;
            btn.classList.toggle("is-selected", isSelected);
            btn.setAttribute("aria-selected", isSelected ? "true" : "false");
          });
          if (selectRateState === "error" || selectRateState === "done") {
            selectRateState = "idle";
          }
          updateShippingRatesConfirmButton();
        }

        function getSelectedRate() {
          if (
            selectedRateIndex < 0 ||
            selectedRateIndex >= loadedRates.length
          ) {
            return null;
          }
          return loadedRates[selectedRateIndex];
        }

        function buildSelectedFinalRatePayload(rate) {
          return {
            provider_code: rate.provider_code || "",
            service_code: rate.service_code || "",
            service_name: rate.service_name || "",
            carrier_amount:
              rate.carrier_amount != null ? Number(rate.carrier_amount) : 0,
            customer_amount:
              rate.customer_amount != null ? Number(rate.customer_amount) : 0,
            carrier_currency: rate.carrier_currency || "",
            delivery_days_min:
              rate.delivery_days_min != null ? rate.delivery_days_min : null,
            delivery_days_max:
              rate.delivery_days_max != null ? rate.delivery_days_max : null,
            delivery_type: rate.delivery_type || "",
            notes: rate.notes != null ? rate.notes : null,
            pricing_rule_id: rate.pricing_rule_id != null ? rate.pricing_rule_id : null,
          };
        }

        function updateShippingRatesConfirmButton() {
          if (!shippingRatesConfirm) {
            return;
          }

          if (calculationPayloadConfirmed) {
            shippingRatesConfirm.hidden = true;
            shippingRatesConfirm.disabled = true;
            return;
          }

          if (!isShipmentConfirmationMode()) {
            shippingRatesConfirm.hidden = true;
            shippingRatesConfirm.disabled = true;
            shippingRatesConfirm.classList.remove("is-loading");
            shippingRatesConfirm.setAttribute("aria-busy", "false");
            if (shippingRatesConfirmError) {
              shippingRatesConfirmError.hidden = true;
              shippingRatesConfirmError.textContent = "";
            }
            return;
          }

          var hasSelectedRate =
            ratesLoadState === "ready" &&
            loadedRates.length > 0 &&
            getSelectedRate() != null;
          var confirmLabel = shippingRatesConfirm.querySelector(
            ".shipping-rates-confirm__label"
          );
          var confirmSpinner = shippingRatesConfirm.querySelector(
            ".shipping-rates-confirm__spinner"
          );
          var isSubmitting = selectRateState === "submitting";

          shippingRatesConfirm.hidden = !hasSelectedRate;
          shippingRatesConfirm.disabled = !hasSelectedRate || isSubmitting;
          shippingRatesConfirm.classList.toggle("is-loading", isSubmitting);
          shippingRatesConfirm.setAttribute("aria-busy", isSubmitting ? "true" : "false");

          if (confirmLabel) {
            confirmLabel.hidden = isSubmitting;
            if (!isSubmitting) {
              confirmLabel.textContent = t("confirm");
            }
          }
          if (confirmSpinner) {
            confirmSpinner.hidden = !isSubmitting;
          }

          if (shippingRatesConfirmError) {
            shippingRatesConfirmError.hidden = selectRateState !== "error";
            if (selectRateState === "error") {
              shippingRatesConfirmError.textContent = t("shippingRatesConfirmFailed");
            } else {
              shippingRatesConfirmError.textContent = "";
            }
          }
        }

        function confirmSelectedRate() {
          if (!isShipmentConfirmationMode()) {
            confirmDeliverySettings();
            return;
          }
          var rate = getSelectedRate();
          if (
            !rate ||
            !calculationPayloadId ||
            !api ||
            selectRateState === "submitting" ||
            calculationPayloadConfirmed
          ) {
            if (calculationPayloadConfirmed) {
              showWidgetErrorPopup(t("calculationPayloadAlreadyConfirmed"));
            }
            return;
          }

          selectRateState = "submitting";
          updateShippingRatesConfirmButton();

          api
            .selectRate(calculationPayloadId, buildSelectedFinalRatePayload(rate))
            .then(function () {
              selectRateState = "done";
              updateShippingRatesConfirmButton();
            })
            .catch(function (err) {
              if (err && err.status === 409) {
                calculationPayloadConfirmed = true;
                showWidgetErrorPopup(t("calculationPayloadAlreadyConfirmed"));
                selectRateState = "idle";
                suppressShippingRatesForConfirmedPayload();
              } else {
                selectRateState = "error";
                updateShippingRatesConfirmButton();
              }
            });
        }

        function confirmDeliverySettings() {
          if (!api || selectRateState === "submitting") {
            return;
          }
          var deliveryType = resolveMatchingTypeOption(selectedType, loadedTypes) || selectedType;
          var latestAddress = deliveryType ? findLatestAddressForType(deliveryType) : null;
          if (!deliveryType || !latestAddress) {
            return;
          }

          selectRateState = "submitting";
          updateShippingRatesConfirmButton();

          activateDeliveryAddress(latestAddress.id, deliveryType, {
            skipTypeChange: true,
            activateOnly: true,
            closeModal: true,
            rethrowOnError: true,
            silentError: true,
          })
            .then(function () {
              selectRateState = "done";
              updateShippingRatesConfirmButton();
              window.setTimeout(function () {
                if (selectRateState === "done") {
                  selectRateState = "idle";
                  updateShippingRatesConfirmButton();
                }
              }, 500);
            })
            .catch(function () {
              selectRateState = "error";
              updateShippingRatesConfirmButton();
            });
        }

        function syncRatesCarouselCardWidths(viewport, row) {
          var gap = 8;
          var viewportWidth = viewport.clientWidth;
          if (!viewportWidth) {
            return;
          }
          var cardWidth =
            (viewportWidth - gap * (RATES_CAROUSEL_VISIBLE_COUNT - 1)) /
            RATES_CAROUSEL_VISIBLE_COUNT;
          row.querySelectorAll(".shipping-rates-card").forEach(function (card) {
            card.style.flex = "0 0 " + cardWidth + "px";
            card.style.maxWidth = cardWidth + "px";
          });
        }

        function applyRatesCarouselTransform(viewport, row, prevBtn, nextBtn) {
          syncRatesCarouselCardWidths(viewport, row);
          clampRatesCarouselOffset();
          var card = row.children[ratesCarouselOffset];
          row.style.transform = card ? "translateX(-" + card.offsetLeft + "px)" : "translateX(0)";
          if (prevBtn) {
            prevBtn.disabled = ratesCarouselOffset <= 0;
          }
          if (nextBtn) {
            nextBtn.disabled = ratesCarouselOffset >= getRatesCarouselMaxOffset();
          }
        }

        function createShippingRateCard(rate, index, row, onSelect) {
          var card = document.createElement("button");
          card.type = "button";
          card.className = "shipping-rates-card";
          if (index === selectedRateIndex) {
            card.classList.add("is-selected");
          }
          card.setAttribute("role", "option");
          card.setAttribute("aria-selected", index === selectedRateIndex ? "true" : "false");

          var header = document.createElement("div");
          header.className = "shipping-rates-card__header";

          var providerIcon = createProviderIconElement(rate.provider_code);
          if (providerIcon) {
            providerIcon.classList.add("shipping-rates-card__provider-icon");
            header.appendChild(providerIcon);
          }

          var title = document.createElement("span");
          title.className = "shipping-rates-card__title";
          title.textContent =
            rate.service_name ||
            rate.service_code ||
            t("shippingRateFallback");
          header.appendChild(title);
          card.appendChild(header);

          var meta = document.createElement("span");
          meta.className = "shipping-rates-card__meta";

          var price = document.createElement("span");
          price.className = "shipping-rates-card__price";
          price.textContent = formatRateAmount(
            rate.customer_amount != null ? rate.customer_amount : rate.carrier_amount,
            rate.customer_currency || rate.carrier_currency
          );
          meta.appendChild(price);

          var daysText = formatRateDeliveryDays(rate);
          if (daysText) {
            meta.appendChild(document.createTextNode(" · "));
            var days = document.createElement("span");
            days.className = "shipping-rates-card__days";
            days.textContent = daysText;
            meta.appendChild(days);
          }
          card.appendChild(meta);

          if (rate.notes) {
            var notes = document.createElement("span");
            notes.className = "shipping-rates-card__notes";
            notes.textContent = rate.notes;
            card.appendChild(notes);
          }

          card.addEventListener("click", function () {
            selectedRateIndex = index;
            ensureSelectedRateVisible();
            updateShippingRateCardSelection(row);
            if (typeof onSelect === "function") {
              onSelect();
            }
          });

          return card;
        }

        function renderShippingRatesPanel() {
          if (!shippingRatesPanel) {
            return;
          }

          shippingRatesPanel.hidden = false;
          shippingRatesPanel.className = "shipping-rates-panel";
          shippingRatesPanel.innerHTML = "";

          if (ratesLoadState === "loading") {
            shippingRatesPanel.classList.add("is-loading");
            var spinnerWrap = document.createElement("div");
            spinnerWrap.className = "shipping-rates-panel__loading";
            spinnerWrap.setAttribute("aria-live", "polite");
            spinnerWrap.setAttribute("aria-busy", "true");

            var spinner = document.createElement("div");
            spinner.className = "shipping-rates-spinner";
            spinner.setAttribute("aria-hidden", "true");
            spinnerWrap.appendChild(spinner);

            var loadingText = document.createElement("p");
            loadingText.className = "shipping-rates-panel__loading-text";
            loadingText.textContent = t("shippingRatesLoading");
            spinnerWrap.appendChild(loadingText);

            shippingRatesPanel.appendChild(spinnerWrap);
            updateShippingRatesConfirmButton();
            return;
          }

          if (ratesLoadState === "error") {
            var errorNode = document.createElement("p");
            errorNode.className = "shipping-rates-panel__error";
            errorNode.textContent = t("shippingRatesLoadFailed");
            shippingRatesPanel.appendChild(errorNode);
            updateShippingRatesConfirmButton();
            return;
          }

          if (ratesLoadState === "empty" || !loadedRates.length) {
            var emptyNode = document.createElement("p");
            emptyNode.className = "shipping-rates-panel__error";
            emptyNode.textContent = t("shippingNotPossible");
            shippingRatesPanel.appendChild(emptyNode);
            updateShippingRatesConfirmButton();
            return;
          }

          var row = document.createElement("div");
          row.className = "shipping-rates-row";
          row.setAttribute("role", "listbox");
          row.setAttribute("aria-label", t("shippingRatesLabel"));

          if (selectedRateIndex >= loadedRates.length) {
            selectedRateIndex = 0;
          }

          var useCarousel = loadedRates.length > RATES_CAROUSEL_VISIBLE_COUNT;
          if (!useCarousel) {
            ratesCarouselOffset = 0;
          } else {
            clampRatesCarouselOffset();
          }

          if (useCarousel) {
            var carousel = document.createElement("div");
            carousel.className = "shipping-rates-carousel";

            var prevBtn = document.createElement("button");
            prevBtn.type = "button";
            prevBtn.className = "shipping-rates-carousel__nav shipping-rates-carousel__nav--prev";
            prevBtn.setAttribute("aria-label", t("shippingRatesPrev"));
            prevBtn.textContent = "\u2039";

            var viewport = document.createElement("div");
            viewport.className = "shipping-rates-carousel__viewport";
            row.classList.add("shipping-rates-row--carousel");

            var nextBtn = document.createElement("button");
            nextBtn.type = "button";
            nextBtn.className = "shipping-rates-carousel__nav shipping-rates-carousel__nav--next";
            nextBtn.setAttribute("aria-label", t("shippingRatesNext"));
            nextBtn.textContent = "\u203A";

            loadedRates.forEach(function (rate, index) {
              row.appendChild(
                createShippingRateCard(rate, index, row, function () {
                  applyRatesCarouselTransform(viewport, row, prevBtn, nextBtn);
                })
              );
            });

            viewport.appendChild(row);

            prevBtn.addEventListener("click", function () {
              if (ratesCarouselOffset <= 0) {
                return;
              }
              ratesCarouselOffset -= 1;
              applyRatesCarouselTransform(viewport, row, prevBtn, nextBtn);
            });

            nextBtn.addEventListener("click", function () {
              if (ratesCarouselOffset >= getRatesCarouselMaxOffset()) {
                return;
              }
              ratesCarouselOffset += 1;
              applyRatesCarouselTransform(viewport, row, prevBtn, nextBtn);
            });

            carousel.appendChild(prevBtn);
            carousel.appendChild(viewport);
            carousel.appendChild(nextBtn);
            shippingRatesPanel.appendChild(carousel);

            requestAnimationFrame(function () {
              applyRatesCarouselTransform(viewport, row, prevBtn, nextBtn);
            });

            if (window.ResizeObserver) {
              var ratesCarouselResizeObserver = new ResizeObserver(function () {
                applyRatesCarouselTransform(viewport, row, prevBtn, nextBtn);
              });
              ratesCarouselResizeObserver.observe(viewport);
            }
          } else {
            loadedRates.forEach(function (rate, index) {
              row.appendChild(createShippingRateCard(rate, index, row));
            });
            shippingRatesPanel.appendChild(row);
          }

          updateShippingRatesConfirmButton();
        }

        function suppressShippingRatesForConfirmedPayload() {
          ratesRequestSequence += 1;
          ratesLoadState = "idle";
          loadedRates = [];
          selectedRateIndex = 0;
          ratesCarouselOffset = 0;
          lastRatesAddressId = null;
          selectRateState = "idle";

          if (shippingRatesSection) {
            shippingRatesSection.hidden = true;
          }
          if (shippingRatesPanel) {
            shippingRatesPanel.hidden = true;
            shippingRatesPanel.innerHTML = "";
          }
          if (shippingRatesConfirmError) {
            shippingRatesConfirmError.hidden = true;
            shippingRatesConfirmError.textContent = "";
          }
          updateShippingRatesConfirmButton();
        }

        function loadShippingRates(options) {
          options = options || {};
          if (calculationPayloadConfirmed) {
            return;
          }

          var activeAddress = findActiveAddress();
          if (!activeAddress || !calculationPayloadId || !api) {
            return;
          }

          if (
            !options.force &&
            ratesLoadState === "ready" &&
            lastRatesAddressId === activeAddress.id &&
            loadedRates.length
          ) {
            renderShippingRatesPanel();
            return;
          }

          var requestId = ++ratesRequestSequence;
          lastRatesAddressId = activeAddress.id;
          ratesLoadState = "loading";
          loadedRates = [];
          selectedRateIndex = 0;
          ratesCarouselOffset = 0;
          selectRateState = "idle";
          renderShippingRatesPanel();

          var body = { id: calculationPayloadId };
          if (cfg.providerCode) {
            body.provider_code = cfg.providerCode;
          }

          api
            .getRatesForCalculationPayload(body)
            .then(function (data) {
              if (requestId !== ratesRequestSequence) {
                return;
              }
              loadedRates = Array.isArray(data && data.rates) ? data.rates : [];
              ratesLoadState = loadedRates.length ? "ready" : "empty";
              renderShippingRatesPanel();
            })
            .catch(function () {
              if (requestId !== ratesRequestSequence) {
                return;
              }
              loadedRates = [];
              ratesLoadState = "error";
              renderShippingRatesPanel();
            });
        }

        function maybeLoadShippingRates() {
          if (!shippingRatesSection || !shippingRatesPanel) {
            return;
          }

          if (calculationPayloadConfirmed) {
            suppressShippingRatesForConfirmedPayload();
            return;
          }

          if (!calculationPayloadId) {
            shippingRatesSection.hidden = true;
            shippingRatesPanel.hidden = true;
            shippingRatesPanel.innerHTML = "";
            ratesLoadState = "idle";
            loadedRates = [];
            selectRateState = "idle";
            updateShippingRatesConfirmButton();
            return;
          }

          shippingRatesSection.hidden = false;

          if (addressLoadState !== "ready" || !findActiveAddress()) {
            ratesRequestSequence += 1;
            ratesLoadState = "idle";
            loadedRates = [];
            lastRatesAddressId = null;
            selectRateState = "idle";
            shippingRatesPanel.hidden = true;
            shippingRatesPanel.innerHTML = "";
            updateShippingRatesConfirmButton();
            return;
          }

          loadShippingRates();
        }

        function maybeAutoOpenAddressModal() {
          if (
            !isDeliverySelectionReady() ||
            findActiveAddress() ||
            !addressModal.hidden ||
            !newAddressModal.hidden
          ) {
            return;
          }
          if (modalAutoOpenedForType === selectedType) {
            return;
          }
          modalAutoOpenedForType = selectedType;
          openAddressModal();
        }

        function findAddressById(addressId) {
          return (
            loadedAddresses.find(function (address) {
              return address.id === addressId;
            }) || null
          );
        }

        function closeAddressItemMenus() {
          openAddressMenuId = null;
          document.querySelectorAll(".address-modal__item-menu-btn").forEach(function (btn) {
            btn.classList.remove("is-open");
            btn.setAttribute("aria-expanded", "false");
          });
          document.querySelectorAll(".address-modal__item-menu-panel").forEach(function (panel) {
            panel.hidden = true;
            panel.style.top = "";
            panel.style.left = "";
            panel.style.right = "";
          });
        }

        function positionAddressItemMenu(menuBtn, menuPanel) {
          var btnRect = menuBtn.getBoundingClientRect();
          var panelWidth = menuPanel.offsetWidth || 140;
          var panelHeight = menuPanel.offsetHeight || 120;
          var gap = 4;
          var margin = 8;

          var left = btnRect.right - panelWidth;
          if (left < margin) {
            left = margin;
          }
          if (left + panelWidth > window.innerWidth - margin) {
            left = Math.max(margin, window.innerWidth - panelWidth - margin);
          }

          var top = btnRect.bottom + gap;
          if (top + panelHeight > window.innerHeight - margin) {
            top = btnRect.top - panelHeight - gap;
          }
          if (top < margin) {
            top = margin;
          }

          menuPanel.style.left = left + "px";
          menuPanel.style.top = top + "px";
          menuPanel.style.right = "auto";
        }

        function toggleAddressItemMenu(addressId, menuBtn, menuPanel) {
          if (openAddressMenuId === addressId) {
            closeAddressItemMenus();
            return;
          }
          closeAddressItemMenus();
          openAddressMenuId = addressId;
          menuBtn.classList.add("is-open");
          menuBtn.setAttribute("aria-expanded", "true");
          menuPanel.hidden = false;
          positionAddressItemMenu(menuBtn, menuPanel);
        }

        function resetNewAddressDeliveryTypeDrafts() {
          newAddressEditorSharedCity = "";
          newAddressCountryDrafts = {};
          newAddressDeliveryTypeDrafts = {
            pickup: { pickupPointId: "", pickupPointLabel: "" },
            courier: { addressLine: "" },
          };
        }

        function createEmptyNewAddressCountryDraft() {
          return {
            city: "",
            pickup: { pickupPointId: "", pickupPointLabel: "" },
            courier: { addressLine: "" },
            pickupPointsByCity: {},
          };
        }

        function getCountryDraftPickupPoints(countryAlpha2, city) {
          var draft = getNewAddressCountryDraft(countryAlpha2);
          if (!draft.pickupPointsByCity || !city) {
            return null;
          }
          if (!Object.prototype.hasOwnProperty.call(draft.pickupPointsByCity, city)) {
            return null;
          }
          return draft.pickupPointsByCity[city];
        }

        function setCountryDraftPickupPoints(countryAlpha2, city, points) {
          if (!city) {
            return;
          }
          var draft = getNewAddressCountryDraft(countryAlpha2);
          if (!draft.pickupPointsByCity) {
            draft.pickupPointsByCity = {};
          }
          draft.pickupPointsByCity[city] = Array.isArray(points) ? points.slice() : [];
        }

        function rememberCurrentPickupPointsForCountry(countryAlpha2) {
          if (!countryAlpha2 || !isPickupDeliveryMode(newAddressDeliveryType)) {
            return;
          }
          var cityInput = getNewAddressCityInput();
          var city = cityInput ? resolveSelectedCity(cityInput.value) : "";
          if (!city || newAddressPickupPointsLoadedCity !== city) {
            return;
          }
          setCountryDraftPickupPoints(countryAlpha2, city, newAddressPickupPoints);
        }

        function getNewAddressCountryDraft(countryAlpha2) {
          var key = normalizeCountryAlpha2(countryAlpha2);
          if (!key) {
            return createEmptyNewAddressCountryDraft();
          }
          if (!newAddressCountryDrafts[key]) {
            newAddressCountryDrafts[key] = createEmptyNewAddressCountryDraft();
          }
          return newAddressCountryDrafts[key];
        }

        function captureNewAddressEditorStateForCountry(countryAlpha2) {
          var draft = getNewAddressCountryDraft(countryAlpha2);
          var cityInput = getNewAddressCityInput();
          draft.city = cityInput ? cityInput.value : "";
          rememberCurrentPickupPointsForCountry(countryAlpha2);
          if (isPickupDeliveryMode(newAddressDeliveryType)) {
            var pickupInput = getNewAddressPickupPointInput();
            draft.pickup = {
              pickupPointId:
                pickupInput && pickupInput.dataset.selectedPickupPointId
                  ? String(pickupInput.dataset.selectedPickupPointId)
                  : "",
              pickupPointLabel: pickupInput ? pickupInput.value : "",
            };
            return;
          }
          var addressInput = newAddressForm.querySelector('[name="address"]');
          draft.courier = {
            addressLine: addressInput ? addressInput.value : "",
          };
        }

        function applyNewAddressCountryDraft(countryAlpha2) {
          var draft = getNewAddressCountryDraft(countryAlpha2);
          newAddressEditorSharedCity = draft.city || "";
          newAddressDeliveryTypeDrafts = {
            pickup: {
              pickupPointId: draft.pickup.pickupPointId || "",
              pickupPointLabel: draft.pickup.pickupPointLabel || "",
            },
            courier: { addressLine: draft.courier.addressLine || "" },
          };
          var cityInput = getNewAddressCityInput();
          if (cityInput) {
            cityInput.value = newAddressEditorSharedCity;
          }
          if (!isPickupDeliveryMode(newAddressDeliveryType)) {
            var addressInput = newAddressForm.querySelector('[name="address"]');
            if (addressInput) {
              addressInput.value = draft.courier.addressLine || "";
            }
          }
        }

        function captureNewAddressEditorState() {
          if (newAddressSelectedCountryAlpha2) {
            captureNewAddressEditorStateForCountry(newAddressSelectedCountryAlpha2);
          }
          var draft = newAddressSelectedCountryAlpha2
            ? getNewAddressCountryDraft(newAddressSelectedCountryAlpha2)
            : null;
          if (draft) {
            newAddressEditorSharedCity = draft.city || "";
            newAddressDeliveryTypeDrafts = {
              pickup: {
                pickupPointId: draft.pickup.pickupPointId || "",
                pickupPointLabel: draft.pickup.pickupPointLabel || "",
              },
              courier: { addressLine: draft.courier.addressLine || "" },
            };
            return;
          }
          var cityInput = getNewAddressCityInput();
          if (cityInput && cityInput.value.trim()) {
            newAddressEditorSharedCity = cityInput.value;
          }
          if (isPickupDeliveryMode(newAddressDeliveryType)) {
            var pickupInput = getNewAddressPickupPointInput();
            newAddressDeliveryTypeDrafts.pickup = {
              pickupPointId:
                pickupInput && pickupInput.dataset.selectedPickupPointId
                  ? String(pickupInput.dataset.selectedPickupPointId)
                  : "",
              pickupPointLabel: pickupInput ? pickupInput.value : "",
            };
            return;
          }
          var addressInput = newAddressForm.querySelector('[name="address"]');
          newAddressDeliveryTypeDrafts.courier = {
            addressLine: addressInput ? addressInput.value : "",
          };
        }

        function restoreNewAddressEditorStateForType(type) {
          var cityInput = getNewAddressCityInput();
          if (cityInput && newAddressEditorSharedCity) {
            cityInput.value = newAddressEditorSharedCity;
          }
          if (isPickupDeliveryMode(type)) {
            var pickupDraft = newAddressDeliveryTypeDrafts.pickup || {};
            var pickupInput = getNewAddressPickupPointInput();
            if (pickupInput) {
              pickupInput.value = pickupDraft.pickupPointLabel || "";
              if (pickupDraft.pickupPointId) {
                pickupInput.dataset.selectedPickupPointId = String(pickupDraft.pickupPointId);
              } else {
                delete pickupInput.dataset.selectedPickupPointId;
              }
            }
            var city = cityInput ? resolveSelectedCity(cityInput.value) : "";
            if (city) {
              pendingPickupPointId = pickupDraft.pickupPointId
                ? String(pickupDraft.pickupPointId)
                : null;
              newAddressPickupPointsLoadedCity = "";
              loadNewAddressPickupPoints({ preferCountryDraft: true });
            } else {
              refreshNewAddressMapFocus();
            }
            return;
          }
          var courierDraft = newAddressDeliveryTypeDrafts.courier || {};
          var addressInput = newAddressForm.querySelector('[name="address"]');
          if (addressInput) {
            addressInput.value = courierDraft.addressLine || "";
          }
          var resolvedCity = cityInput
            ? resolveSelectedCity(cityInput.value) || cityInput.value.trim()
            : "";
          var addressLine = addressInput ? addressInput.value.trim() : "";
          if (resolvedCity || addressLine) {
            focusNewAddressMapOnLocation(resolvedCity, addressLine);
          } else {
            refreshNewAddressMapFocus();
          }
        }

        function resetNewAddressFormFields() {
          newAddressForm.querySelector('[name="address"]').value = "";
          clearNewAddressPickupPointSelection();
          resetNewAddressPostalCodeState();
          var contactFirstNameInput = getContactFirstNameInput();
          var contactLastNameInput = getContactLastNameInput();
          var contactEmailInput = getContactEmailInput();
          if (contactFirstNameInput) {
            contactFirstNameInput.value = "";
          }
          if (contactLastNameInput) {
            contactLastNameInput.value = "";
          }
          if (contactEmailInput) {
            contactEmailInput.value = "";
          }
          var contactPhoneInput = getContactPhoneInput();
          if (contactPhoneInput) {
            contactPhoneInput.value = "";
          }
          updateContactPhoneField();
          var cityInput = getNewAddressCityInput();
          if (cityInput) {
            cityInput.value = "";
          }
          setCountryComboboxState(false, "", "");
        }

        function resetNewAddressPickupPointsEditorState() {
          newAddressEditorRequiresPickupPoints = false;
          newAddressPickupPointsLoadPending = 0;
          newAddressPickupPointsLoadedCity = "";
          newAddressPickupPointsLoadingCity = "";
          newAddressPickupPoints = [];
        }

        function isNewAddressPickupSettlementPending() {
          if (!isPickupDeliveryMode(newAddressDeliveryType)) {
            return false;
          }
          if (!newAddressEditorRequiresPickupPoints) {
            return false;
          }
          var cityInput = getNewAddressCityInput();
          if (!cityInput || !cityInput.value.trim()) {
            return false;
          }
          var city = resolveSelectedCity(cityInput.value);
          if (!city) {
            return true;
          }
          if (newAddressPickupPointsLoadPending > 0) {
            return true;
          }
          if (newAddressPickupPointsLoadingCity === city) {
            return true;
          }
          if (newAddressPickupPointsLoadedCity !== city) {
            return true;
          }
          if (pendingPickupPointId) {
            return true;
          }
          return false;
        }

        function isNewAddressDeliveryTypeSelectorLocked() {
          if (newAddressEditorBootstrapActive) {
            return true;
          }
          if (newAddressPickupPointsLoadPending > 0) {
            return true;
          }
          return isNewAddressPickupSettlementPending();
        }

        function settleNewAddressPickupPointsForCity(city) {
          if (!city || newAddressPickupPointsLoadedCity !== city) {
            return;
          }
          if (!pendingPickupPointId) {
            newAddressEditorRequiresPickupPoints = false;
          }
          updateNewAddressEditorInteractivity();
        }

        function canCompleteNewAddressPickupBootstrap() {
          return !isNewAddressPickupSettlementPending();
        }

        function beginNewAddressEditorBootstrap() {
          newAddressEditorBootstrapActive = true;
          newAddressEditorCitiesReady = false;
          newAddressEditorPickupPointsReady = false;
          newAddressPickupPointsLoadedCity = "";
          newAddressPickupPointsLoadingCity = "";
          newAddressPickupPoints = [];
          setNewAddressEditorLoading();
        }

        function keepNewAddressDeliveryTypeLockedDuringBootstrap() {
          if (!newAddressEditorBootstrapActive) {
            return;
          }
          newAddressEditorPickupPointsReady = false;
        }

        function beginNewAddressPickupPointsFetch() {
          newAddressPickupPointsLoadPending += 1;
          keepNewAddressDeliveryTypeLockedDuringBootstrap();
          updateNewAddressEditorInteractivity();
        }

        function endNewAddressPickupPointsFetch() {
          if (newAddressPickupPointsLoadPending > 0) {
            newAddressPickupPointsLoadPending -= 1;
          }
          updateNewAddressEditorInteractivity();
        }

        function markNewAddressEditorCitiesReady() {
          if (!newAddressEditorBootstrapActive) {
            return;
          }
          newAddressEditorCitiesReady = true;
          markNewAddressEditorBootstrapProgress();
        }

        function markNewAddressEditorPickupPointsReady() {
          if (!newAddressEditorBootstrapActive) {
            return;
          }
          if (!canCompleteNewAddressPickupBootstrap()) {
            return;
          }
          newAddressEditorPickupPointsReady = true;
          markNewAddressEditorBootstrapProgress();
        }

        function markNewAddressEditorBootstrapProgress() {
          if (!newAddressEditorBootstrapActive || !newAddressEditorCitiesReady) {
            return;
          }
          if (!canCompleteNewAddressPickupBootstrap()) {
            return;
          }
          if (
            isPickupDeliveryMode(newAddressDeliveryType) &&
            !newAddressEditorPickupPointsReady
          ) {
            return;
          }
          maybeFinishNewAddressEditorBootstrap();
        }

        function maybeFinishNewAddressEditorBootstrap() {
          if (!newAddressEditorBootstrapActive) {
            return;
          }
          newAddressEditorBootstrapActive = false;
          updateNewAddressEditorInteractivity();
          captureNewAddressEditorState();
        }

        function isNewAddressEditorLocked() {
          return (
            newAddressEditorBootstrapActive ||
            newAddressPickupPointsLoadPending > 0 ||
            isNewAddressDeliveryTypeSelectorLocked()
          );
        }

        function updateNewAddressEditorInteractivity() {
          var locked = isNewAddressEditorLocked();
          var deliveryTypeLocked = isNewAddressDeliveryTypeSelectorLocked();
          if (newAddressForm) {
            newAddressForm.classList.toggle("is-loading", locked);
            newAddressForm.setAttribute("aria-busy", locked ? "true" : "false");
            newAddressForm.inert = locked;
          }
          if (newAddressDeliveryTypeRow) {
            newAddressDeliveryTypeRow.classList.toggle("is-loading", deliveryTypeLocked);
            newAddressDeliveryTypeRow.inert = deliveryTypeLocked;
          }
          if (newAddressMapContainer) {
            newAddressMapContainer.classList.toggle("is-loading", locked);
          }
          setNewAddressDeliveryTypeButtonsDisabled(deliveryTypeLocked);
          setCountryComboboxDisabled(locked);
          newAddressModalSave.disabled =
            locked || newAddressSaving || isNewAddressPostalCodeBlocking();
          updateNewAddressPostalCodeUi();
          updateContactPhoneField();
        }

        function setNewAddressEditorLoading() {
          updateNewAddressEditorInteractivity();
        }

        function setNewAddressDeliveryTypeButtonsDisabled(disabled) {
          if (!newAddressDeliveryTypeRow) {
            return;
          }
          newAddressDeliveryTypeRow.querySelectorAll(".delivery-type-btn").forEach(function (btn) {
            btn.disabled = !!disabled;
          });
        }

        function openAddressFormModal(options) {
          options = options || {};
          editingAddressId = options.editingAddressId || null;
          newAddressIsCopy = Boolean(options.isCopy);
          newAddressModalTitle.textContent = editingAddressId
            ? t("changeAddressTitle")
            : t("newAddressTitle");
          newAddressModalSave.textContent = t("save");
          newAddressModalCancel.textContent = t("cancel");
          newAddressPrefill = options.prefill || null;
          pendingPickupPointId = null;
          newAddressPendingPrefillCountryAlpha2 = "";
          if (
            newAddressPrefill &&
            newAddressPrefill.country != null &&
            translations.numericCountryCodeToAlpha2
          ) {
            newAddressPendingPrefillCountryAlpha2 = translations.numericCountryCodeToAlpha2(
              newAddressPrefill.country
            );
          }
          resetNewAddressFormFields();
          resetNewAddressDeliveryTypeDrafts();
          resetNewAddressPickupPointsEditorState();
          if (editingAddressId || newAddressIsCopy) {
            if (
              newAddressPrefill &&
              isPickupDeliveryMode(newAddressPrefill.delivery_type)
            ) {
              newAddressEditorRequiresPickupPoints = true;
            }
            beginNewAddressEditorBootstrap();
          }
          var initialDeliveryType = resolveNewAddressInitialDeliveryType();
          renderNewAddressDeliveryTypeSelector(initialDeliveryType);
          loadNewAddressDestinationCountries();
          newAddressModalError.hidden = true;
          newAddressModalError.textContent = "";
          newAddressSaving = false;
          if (!isNewAddressEditorLocked()) {
            updateNewAddressEditorInteractivity();
          }
          newAddressModal.hidden = false;
          if (addressModal.hidden) {
            document.body.style.overflow = "hidden";
          }
          initNewAddressMap();
        }

        function openEditAddressModal(address) {
          closeAddressItemMenus();
          openAddressFormModal({
            editingAddressId: address.id,
            prefill: address,
          });
        }

        function openCopyAddressModal(address) {
          closeAddressItemMenus();
          openAddressFormModal({
            prefill: address,
            isCopy: true,
          });
        }

        function deleteAddress(address) {
          closeAddressItemMenus();
          if (!address || !address.id) {
            return;
          }
          if (!window.confirm(t("addressDeleteConfirm"))) {
            return;
          }
          api
            .deleteDeliveryAddress(address.id)
            .then(function () {
              if (modalSelectedAddressId === address.id) {
                modalSelectedAddressId = null;
              }
              return loadDeliveryAddresses().then(function () {
                renderAddressUi();
              });
            })
            .catch(function () {
              if (!addressModal.hidden) {
                addressModalError.hidden = false;
                addressModalError.textContent = t("addressDeleteFailed");
                return;
              }
              window.alert(t("addressDeleteFailed"));
            });
        }

        function createAddressItemMenu(address) {
          var menu = document.createElement("div");
          menu.className = "address-modal__item-menu";

          var menuBtn = document.createElement("button");
          menuBtn.type = "button";
          menuBtn.className = "address-modal__item-menu-btn";
          menuBtn.setAttribute("aria-label", t("addressMenuLabel"));
          menuBtn.setAttribute("aria-haspopup", "menu");
          menuBtn.setAttribute("aria-expanded", "false");
          menuBtn.innerHTML =
            '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">' +
            '<circle cx="8" cy="3" r="1.5" fill="currentColor"></circle>' +
            '<circle cx="8" cy="8" r="1.5" fill="currentColor"></circle>' +
            '<circle cx="8" cy="13" r="1.5" fill="currentColor"></circle>' +
            "</svg>";

          var menuPanel = document.createElement("div");
          menuPanel.className = "address-modal__item-menu-panel";
          menuPanel.setAttribute("role", "menu");
          menuPanel.hidden = true;

          [
            { action: "edit", label: t("edit") },
            { action: "delete", label: t("delete"), danger: true },
            { action: "copy", label: t("copy") },
          ].forEach(function (item) {
            var actionBtn = document.createElement("button");
            actionBtn.type = "button";
            actionBtn.className =
              "address-modal__item-menu-action" +
              (item.danger ? " address-modal__item-menu-action--danger" : "");
            actionBtn.setAttribute("role", "menuitem");
            actionBtn.setAttribute("data-action", item.action);
            actionBtn.textContent = item.label;
            actionBtn.addEventListener("click", function (event) {
              event.stopPropagation();
              if (item.action === "edit") {
                openEditAddressModal(address);
                return;
              }
              if (item.action === "delete") {
                deleteAddress(address);
                return;
              }
              if (item.action === "copy") {
                openCopyAddressModal(address);
              }
            });
            menuPanel.appendChild(actionBtn);
          });

          menuBtn.addEventListener("click", function (event) {
            event.stopPropagation();
            toggleAddressItemMenu(address.id, menuBtn, menuPanel);
          });
          menu.addEventListener("click", function (event) {
            event.stopPropagation();
          });

          menu.appendChild(menuBtn);
          menu.appendChild(menuPanel);
          return menu;
        }

        function createAddressListItem(address, options) {
          options = options || {};
          var item = document.createElement("div");
          item.className = "address-modal__item";
          item.setAttribute("data-address-id", String(address.id));
          item.setAttribute("role", "button");
          item.setAttribute("tabindex", "0");
          item.setAttribute("aria-pressed", "false");

          var radio = document.createElement("input");
          radio.type = "radio";
          radio.className = "address-modal__item-radio";
          radio.name = options.radioName || "address-selection";
          radio.value = String(address.id);
          radio.checked = !!address.is_active;
          radio.setAttribute(
            "aria-label",
            (address.city || "") + ", " + (address.address || "")
          );
          if (address.is_active) {
            item.classList.add("is-selected");
            item.setAttribute("aria-pressed", "true");
          }

          var body = document.createElement("div");
          body.className = "address-modal__item-body";

          var city = document.createElement("p");
          city.className = "address-modal__item-city";
          city.textContent = address.city || "—";

          var lineRow = createAddressLineWithProviderIcon(
            address.address,
            address.provider_code,
            "address-modal__item-line",
            "address-modal__item-line-row"
          );

          var contact = formatContactInfo(address.contact_info);
          if (contact) {
            var contactLine = document.createElement("p");
            contactLine.className = "address-modal__item-contact";
            contactLine.textContent = contact;
            body.appendChild(city);
            body.appendChild(lineRow);
            body.appendChild(contactLine);
          } else {
            body.appendChild(city);
            body.appendChild(lineRow);
          }

          var meta = document.createElement("p");
          meta.className = "address-modal__item-meta";
          meta.appendChild(createDeliveryTypeIconElement(address.delivery_type));
          var metaLabel = document.createElement("span");
          metaLabel.textContent = labelForType(address.delivery_type);
          meta.appendChild(metaLabel);

          body.appendChild(meta);
          item.appendChild(radio);
          item.appendChild(body);
          item.appendChild(createAddressItemMenu(address));

          function handleSelect() {
            if (typeof options.onSelect === "function") {
              options.onSelect(address.id);
            }
          }

          radio.addEventListener("click", function (event) {
            event.stopPropagation();
          });
          radio.addEventListener("change", function () {
            handleSelect();
          });

          item.addEventListener("click", handleSelect);
          item.addEventListener("keydown", function (event) {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              handleSelect();
            }
          });

          return item;
        }

        function renderAddButtonLabel() {
          if (!addressModalAdd) {
            return;
          }
          if (translations.formatLabel) {
            addressModalAdd.innerHTML = translations.formatLabel(
              "add",
              locale,
              companyCountryAlpha2
            );
            return;
          }
          addressModalAdd.textContent =
            t("add") + (companyCountryAlpha2 ? "_" + companyCountryAlpha2 : "");
        }

        function openAddressModal() {
          if (!loadedAddresses.length) {
            openNewAddressModal();
            return;
          }
          closeAddressItemMenus();
          resetAddressModalFilter();
          addressModalTitle.textContent = t("changeAddressTitle");
          addressModalConfirm.textContent = t("done");
          if (addressModalFilter) {
            addressModalFilter.placeholder = t("addressFilterPlaceholder");
          }
          renderAddButtonLabel();
          renderAddressModalList();
          addressModal.hidden = false;
          document.body.style.overflow = "hidden";
        }

        function closeAddressModal() {
          addressModal.hidden = true;
          closeAddressItemMenus();
          resetAddressModalFilter();
          document.body.style.overflow = "";
          modalSelectedAddressId = null;
          modalConfirming = false;
          addressModalError.hidden = true;
          addressModalError.textContent = "";
        }

        // New address modal window
        function resolveNewAddressTypeOptions() {
          if (loadedTypes.length) {
            return loadedTypes.slice();
          }
          return ["pickup", "courier"];
        }

        function resolveNewAddressInitialDeliveryType() {
          var types = resolveNewAddressTypeOptions();
          if (!types.length) {
            return null;
          }
          if (editingAddressId || newAddressIsCopy) {
            if (newAddressPrefill && newAddressPrefill.delivery_type) {
              return resolveMatchingTypeOption(newAddressPrefill.delivery_type, types);
            }
            return resolveMatchingTypeOption(selectedType, types);
          }
          return (
            resolveConfiguredDefaultDeliveryType(types) ||
            resolveMatchingTypeOption(selectedType, types)
          );
        }

        function isPickupDeliveryMode(type) {
          return resolveCitiesDeliveryTypeParam(type) === "pickup";
        }

        function getDeliveryTypeIconUrl(type) {
          return isPickupDeliveryMode(type)
            ? "./images/pickup-point.png"
            : "./images/courier.png";
        }

        function createDeliveryTypeIconElement(type) {
          var icon = document.createElement("img");
          icon.className = "delivery-type-icon";
          icon.src = getDeliveryTypeIconUrl(type);
          icon.alt = "";
          icon.setAttribute("aria-hidden", "true");
          return icon;
        }

        function updateNewAddressFormForDeliveryType() {
          var pickupField = document.getElementById("new-address-pickup-point-field");
          var addressField = document.getElementById("new-address-address-field");
          var addressInput = newAddressForm.querySelector('[name="address"]');
          var pickupInput = getNewAddressPickupPointInput();
          var isPickup = isPickupDeliveryMode(newAddressDeliveryType);

          if (pickupField) {
            pickupField.hidden = !isPickup;
          }
          if (addressField) {
            addressField.hidden = isPickup;
          }
          if (addressInput) {
            addressInput.required = !isPickup;
          }
          if (pickupInput) {
            pickupInput.required = isPickup;
          }
          if (!isPickup) {
            closePickupPointCombobox();
          } else if (!newAddressEditorBootstrapActive) {
            var cityInput = getNewAddressCityInput();
            var city = cityInput ? resolveSelectedCity(cityInput.value) : "";
            if (city) {
              loadNewAddressPickupPoints();
            }
          }
        }

        function getPickupPointProviderIconUrl(providerCode) {
          var normalized = String(providerCode || "")
            .trim()
            .toLowerCase();
          return normalized ? "./images/" + normalized + ".png" : "";
        }

        function createProviderIconElement(providerCode) {
          var label = String(providerCode || "").trim();
          var iconUrl = getPickupPointProviderIconUrl(providerCode);
          if (!iconUrl) {
            return null;
          }
          var icon = document.createElement("img");
          icon.className = "provider-icon";
          icon.src = iconUrl;
          icon.alt = "";
          if (label) {
            icon.title = label;
            icon.setAttribute("aria-label", label);
          } else {
            icon.setAttribute("aria-hidden", "true");
          }
          icon.addEventListener("error", function () {
            icon.remove();
          });
          return icon;
        }

        function getPickupPointLabel(point) {
          if (!point) {
            return "";
          }
          var name = point.name || point.external_id || "";
          var line = getPickupPointAddressLine(point);
          if (line && line.toLowerCase() !== String(name).toLowerCase()) {
            return name + " · " + line;
          }
          return name || line;
        }

        function getPickupPointAddressLine(point) {
          if (!point) {
            return "";
          }
          var addr = point.address || {};
          return (
            addr.address ||
            addr.street ||
            addr.line1 ||
            point.name ||
            ""
          );
        }

        function getNewAddressPickupPointInput() {
          return newAddressForm.querySelector('[name="pickupPoint"]');
        }

        function getNewAddressPickupPointListbox() {
          return document.getElementById("new-address-pickup-point-listbox");
        }

        function clearNewAddressPickupPointSelection() {
          var input = getNewAddressPickupPointInput();
          if (!input) {
            return;
          }
          input.value = "";
          delete input.dataset.selectedPickupPointId;
          closePickupPointCombobox();
          resetNewAddressPostalCodeState();
        }

        function closePickupPointCombobox() {
          var listbox = getNewAddressPickupPointListbox();
          var input = getNewAddressPickupPointInput();
          if (listbox) {
            listbox.hidden = true;
          }
          if (input) {
            input.setAttribute("aria-expanded", "false");
          }
        }

        function resolveSelectedPickupPoint() {
          var input = getNewAddressPickupPointInput();
          if (!input || !input.dataset.selectedPickupPointId) {
            return null;
          }
          var selectedId = input.dataset.selectedPickupPointId;
          return (
            newAddressPickupPoints.find(function (point) {
              return String(point.id) === String(selectedId);
            }) || null
          );
        }

        function selectPickupPointOption(point) {
          var input = getNewAddressPickupPointInput();
          if (input) {
            input.value = getPickupPointLabel(point);
            input.dataset.selectedPickupPointId = String(point.id);
          }
          renderPickupPointComboboxOptions();
          closePickupPointCombobox();
          focusNewAddressMapOnPickupPoint(point);
          captureNewAddressEditorState();
        }

        function getFilteredPickupPoints(query, options) {
          options = options || {};
          if (!newAddressPickupPoints.length) {
            return [];
          }
          if (options.showAll) {
            return newAddressPickupPoints.slice();
          }
          var trimmed = String(query || "").trim();
          if (!trimmed) {
            return newAddressPickupPoints.slice();
          }
          var needle = trimmed.toLowerCase();
          return newAddressPickupPoints.filter(function (point) {
            return getPickupPointLabel(point).toLowerCase().indexOf(needle) !== -1;
          });
        }

        function renderPickupPointComboboxOptions(options) {
          options = options || {};
          var listbox = getNewAddressPickupPointListbox();
          var input = getNewAddressPickupPointInput();
          if (!listbox || !input || input.disabled) {
            return;
          }
          var selectedPoint = resolveSelectedPickupPoint();
          var filterQuery = options.showAll ? "" : input.value;
          var filteredPoints = getFilteredPickupPoints(filterQuery, options);
          listbox.innerHTML = "";
          filteredPoints.forEach(function (point) {
            var option = document.createElement("li");
            option.className =
              "new-address-modal__combobox-option new-address-modal__combobox-option--pickup-point";
            option.setAttribute("role", "option");
            if (selectedPoint && String(selectedPoint.id) === String(point.id)) {
              option.classList.add("is-selected");
              option.setAttribute("aria-selected", "true");
            } else {
              option.setAttribute("aria-selected", "false");
            }

            var label = document.createElement("span");
            label.className = "new-address-modal__pickup-point-label";
            label.textContent = getPickupPointLabel(point);
            option.appendChild(label);

            var icon = createProviderIconElement(point.provider_code);
            if (icon) {
              option.appendChild(icon);
            }

            option.addEventListener("mousedown", function (event) {
              event.preventDefault();
              selectPickupPointOption(point);
            });
            listbox.appendChild(option);
          });
          listbox.hidden = filteredPoints.length === 0;
          input.setAttribute("aria-expanded", filteredPoints.length > 0 ? "true" : "false");
          var selectedNode = listbox.querySelector(".new-address-modal__combobox-option.is-selected");
          if (selectedNode) {
            selectedNode.scrollIntoView({ block: "nearest" });
          }
        }

        function openPickupPointCombobox(options) {
          options = options || {};
          var input = getNewAddressPickupPointInput();
          if (!input || input.disabled || !newAddressPickupPoints.length) {
            return;
          }
          renderPickupPointComboboxOptions(options);
          if (options.showAll) {
            showAllPickupPointsOnMap(newAddressPickupPoints);
          }
        }

        function setPickupPointComboboxState(disabled, placeholder, value, options) {
          options = options || {};
          var input = getNewAddressPickupPointInput();
          if (!input) {
            return;
          }
          input.disabled = !!disabled;
          input.placeholder = placeholder || "";
          if (value !== undefined) {
            input.value = value;
          }
          if (!options.preserveSelection) {
            delete input.dataset.selectedPickupPointId;
          }
          closePickupPointCombobox();
        }

        function restorePickupPointSelectionAfterLoad() {
          var pickupInput = getNewAddressPickupPointInput();
          if (!pickupInput) {
            return;
          }
          if (pendingPickupPointId) {
            applyNewAddressPickupPointPrefill();
            return;
          }
          var selectedId = pickupInput.dataset.selectedPickupPointId;
          if (!selectedId) {
            refreshNewAddressMapFocus();
            return;
          }
          var point = newAddressPickupPoints.find(function (item) {
            return String(item.id) === String(selectedId);
          });
          if (point) {
            pickupInput.value = getPickupPointLabel(point);
            pickupInput.dataset.selectedPickupPointId = String(point.id);
            focusNewAddressMapOnPickupPoint(point);
            return;
          }
          refreshNewAddressMapFocus();
        }

        function applyLoadedPickupPoints(city, points) {
          setCountryDraftPickupPoints(newAddressSelectedCountryAlpha2, city, points);
          newAddressPickupPointsLoadingCity = "";
          newAddressPickupPointsLoadedCity = city;
          newAddressPickupPoints = Array.isArray(points) ? points.slice() : [];
          if (!newAddressPickupPoints.length) {
            setPickupPointComboboxState(true, t("noPickupPointsAvailable"), "");
          } else {
            var pickupInput = getNewAddressPickupPointInput();
            var hasSelection =
              pendingPickupPointId ||
              (pickupInput && pickupInput.dataset.selectedPickupPointId);
            setPickupPointComboboxState(
              false,
              t("newAddressPickupPointPlaceholder"),
              hasSelection && pickupInput ? pickupInput.value : "",
              { preserveSelection: !!hasSelection }
            );
            if (!hasSelection && newAddressPickupPoints.length === 1) {
              selectPickupPointOption(newAddressPickupPoints[0]);
            } else {
              restorePickupPointSelectionAfterLoad();
            }
          }
          settleNewAddressPickupPointsForCity(city);
          if (newAddressEditorBootstrapActive) {
            markNewAddressEditorPickupPointsReady();
          }
        }

        function restorePickupPointsFromCountryDraft(city) {
          var cachedPoints = getCountryDraftPickupPoints(
            newAddressSelectedCountryAlpha2,
            city
          );
          if (cachedPoints === null) {
            return false;
          }
          applyLoadedPickupPoints(city, cachedPoints);
          return true;
        }

        function loadNewAddressPickupPoints(options) {
          options = options || {};
          var forceReload = options.force;
          if (!isPickupDeliveryMode(newAddressDeliveryType)) {
            return;
          }
          var cityInput = getNewAddressCityInput();
          var city = resolveSelectedCity(cityInput ? cityInput.value : "");
          if (!city) {
            newAddressPickupPointsLoadedCity = "";
            newAddressPickupPointsLoadingCity = "";
            newAddressPickupPoints = [];
            setPickupPointComboboxState(true, t("newAddressPickupPointSelectCity"), "");
            if (newAddressEditorBootstrapActive) {
              return;
            }
            return;
          }

          if (options.preferCountryDraft && restorePickupPointsFromCountryDraft(city)) {
            return;
          }

          if (!forceReload) {
            if (city === newAddressPickupPointsLoadedCity) {
              var cachedInput = getNewAddressPickupPointInput();
              if (cachedInput && cachedInput.disabled) {
                if (newAddressPickupPoints.length) {
                  setPickupPointComboboxState(
                    false,
                    t("newAddressPickupPointPlaceholder"),
                    cachedInput.value,
                    { preserveSelection: !!cachedInput.dataset.selectedPickupPointId }
                  );
                } else {
                  setPickupPointComboboxState(true, t("noPickupPointsAvailable"), "");
                }
              }
              applyNewAddressPickupPointPrefill();
              if (newAddressEditorBootstrapActive) {
                markNewAddressEditorPickupPointsReady();
              }
              settleNewAddressPickupPointsForCity(city);
              return;
            }
            if (city === newAddressPickupPointsLoadingCity) {
              updateNewAddressEditorInteractivity();
              return;
            }
            if (restorePickupPointsFromCountryDraft(city)) {
              return;
            }
          }

          beginNewAddressPickupPointsFetch();

          var requestId = ++newAddressPickupPointsRequestId;
          newAddressPickupPointsLoadingCity = city;
          newAddressPickupPoints = [];
          setPickupPointComboboxState(true, t("pickupPointsLoading"), "");

          var query = {
            city: city,
            only_active: true,
            environment: cfg.environment || "TEST",
          };
          if (getEditorCountryAlpha2Lower()) {
            query.country_code = getEditorCountryAlpha2Lower();
          }

          api
            .listPickupPoints(query)
            .then(function (points) {
              if (requestId !== newAddressPickupPointsRequestId || newAddressModal.hidden) {
                return;
              }
              applyLoadedPickupPoints(city, points);
            })
            .catch(function () {
              if (requestId !== newAddressPickupPointsRequestId || newAddressModal.hidden) {
                return;
              }
              newAddressPickupPointsLoadingCity = "";
              newAddressPickupPointsLoadedCity = city;
              newAddressPickupPoints = [];
              setPickupPointComboboxState(true, t("pickupPointsLoadFailed"), "");
              settleNewAddressPickupPointsForCity(city);
              if (newAddressEditorBootstrapActive) {
                markNewAddressEditorPickupPointsReady();
              }
            })
            .finally(function () {
              endNewAddressPickupPointsFetch();
            });
        }

        function focusNewAddressMapOnPickupPoint(point) {
          if (!point || newAddressModal.hidden) {
            return;
          }
          var fromPoint = getPickupPointPostalCode(point);
          if (fromPoint) {
            finishNewAddressPostalCodeLookup(fromPoint);
          } else {
            beginNewAddressPostalCodeLookup();
          }
          var apiKey = (cfg.googleMapsApiKey || "").trim();
          if (!apiKey) {
            if (!fromPoint) {
              finishNewAddressPostalCodeLookup("");
            }
            return;
          }
          var addr = point.address || {};
          var lat = addr.lat != null ? addr.lat : addr.latitude;
          var lng = addr.lng != null ? addr.lng : addr.longitude;
          loadGoogleMaps(apiKey)
            .then(function (maps) {
              if (newAddressModal.hidden || !ensureNewAddressMapInstance(maps)) {
                if (!fromPoint) {
                  finishNewAddressPostalCodeLookup("");
                }
                return;
              }
              window.google.maps.event.trigger(newAddressMapInstance, "resize");
              var requestId = ++newAddressMapGeocodeRequestId;
              function placeMarker(location, geocodeResult) {
                if (!newAddressMapInstance) {
                  return;
                }
                clearNewAddressMapMarkers();
                newAddressMapInstance.setCenter(location);
                newAddressMapInstance.setZoom(14);
                newAddressCityMarker = addNewAddressMapMarker(
                  maps,
                  location,
                  getPickupPointLabel(point),
                  point
                );
                if (!fromPoint) {
                  if (geocodeResult) {
                    applyPostalCodeFromGeocoderResult(geocodeResult);
                  } else {
                    resolvePickupPointPostalCodeFromMaps(
                      point,
                      maps,
                      location,
                      finishNewAddressPostalCodeLookup
                    );
                  }
                }
              }
              if (lat != null && lng != null && !isNaN(Number(lat)) && !isNaN(Number(lng))) {
                placeMarker({ lat: Number(lat), lng: Number(lng) });
                return;
              }
              var alpha2 = getEditorCountryAlpha2Lower();
              var countryName = getCountryGeocodeName(getEditorCountryAlpha2());
              var geocoder = new maps.Geocoder();
              var geocodeRequest = {
                address: getPickupPointLabel(point) + (countryName ? ", " + countryName : ""),
              };
              if (alpha2) {
                geocodeRequest.componentRestrictions = { country: alpha2 };
              }
              geocoder.geocode(geocodeRequest, function (results, status) {
                if (
                  requestId !== newAddressMapGeocodeRequestId ||
                  !newAddressMapInstance ||
                  status !== "OK" ||
                  !results ||
                  !results.length
                ) {
                  if (!fromPoint) {
                    finishNewAddressPostalCodeLookup("");
                  }
                  return;
                }
                placeMarker(results[0].geometry.location, results[0]);
              });
            })
            .catch(function () {
              if (!fromPoint) {
                finishNewAddressPostalCodeLookup("");
              }
            });
        }

        function initNewAddressPickupPointCombobox() {
          var input = getNewAddressPickupPointInput();
          if (!input || input.dataset.comboboxReady === "true") {
            return;
          }
          input.dataset.comboboxReady = "true";
          input.addEventListener("input", function () {
            openPickupPointCombobox({ showAll: false });
          });
          input.addEventListener("focus", function () {
            openPickupPointCombobox({ showAll: true });
          });
          input.addEventListener("click", function () {
            openPickupPointCombobox({ showAll: true });
          });
          input.addEventListener("blur", function () {
            window.setTimeout(closePickupPointCombobox, 150);
          });
          input.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
              closePickupPointCombobox();
            }
          });
        }

        function resolveMatchingTypeOption(type, types) {
          if (!types.length) {
            return null;
          }
          if (type && types.indexOf(type) !== -1) {
            return type;
          }
          if (!type) {
            return types[0];
          }
          var normalizedTarget = resolveCitiesDeliveryTypeParam(type);
          var matched = types.find(function (option) {
            return resolveCitiesDeliveryTypeParam(option) === normalizedTarget;
          });
          return matched || types[0];
        }

        function applyNewAddressPickupPointPrefill() {
          if (!pendingPickupPointId) {
            return;
          }
          var point = newAddressPickupPoints.find(function (item) {
            return String(item.id) === String(pendingPickupPointId);
          });
          pendingPickupPointId = null;
          if (point) {
            selectPickupPointOption(point);
          }
          if (newAddressEditorBootstrapActive) {
            var cityInput = getNewAddressCityInput();
            var city = cityInput ? resolveSelectedCity(cityInput.value) : "";
            if (city) {
              settleNewAddressPickupPointsForCity(city);
            }
            markNewAddressEditorPickupPointsReady();
          } else {
            updateNewAddressEditorInteractivity();
          }
        }

        function applyNewAddressPrefill() {
          if (!newAddressPrefill || newAddressModal.hidden) {
            return;
          }
          var address = newAddressPrefill;
          newAddressPrefill = null;
          var contactInfo = address.contact_info || {};
          var contactFirstNameInput = getContactFirstNameInput();
          var contactLastNameInput = getContactLastNameInput();
          var contactEmailInput = getContactEmailInput();
          var contactPhoneInput = getContactPhoneInput();
          var addressInput = newAddressForm.querySelector('[name="address"]');
          var legacyName = splitLegacyContactName(contactInfo.name);
          if (contactFirstNameInput) {
            contactFirstNameInput.value = String(
              contactInfo.first_name || legacyName.firstName || ""
            );
          }
          if (contactLastNameInput) {
            contactLastNameInput.value = String(
              contactInfo.last_name || legacyName.lastName || ""
            );
          }
          if (contactEmailInput && contactInfo.email) {
            contactEmailInput.value = String(contactInfo.email);
          }
          if (contactPhoneInput && contactInfo.phone) {
            contactPhoneInput.value = String(contactInfo.phone);
            updateContactPhoneFlag();
          } else {
            updateContactPhoneField();
          }
          if (address.postal_code) {
            newAddressPostalCode = String(address.postal_code).trim();
            newAddressPostalCodePending = false;
            refreshNewAddressPostalCodeState();
          }
          if (!isPickupDeliveryMode(newAddressDeliveryType) && addressInput) {
            addressInput.value = address.address || "";
          }
          var city = resolveSelectedCity(address.city || "");
          var cityInput = getNewAddressCityInput();
          if (!city || !cityInput) {
            if (address.city && cityInput) {
              cityInput.value = String(address.city);
            }
            captureNewAddressEditorState();
            if (isPickupDeliveryMode(newAddressDeliveryType) && newAddressEditorRequiresPickupPoints) {
              var cityAfterSet = resolveSelectedCity(cityInput ? cityInput.value : "");
              if (cityAfterSet) {
                if (address.pickup_point_id) {
                  pendingPickupPointId = String(address.pickup_point_id);
                }
                loadNewAddressPickupPoints({ force: true });
                return;
              }
              return;
            }
            if (newAddressEditorBootstrapActive) {
              markNewAddressEditorPickupPointsReady();
            }
            return;
          }
          cityInput.value = city;
          captureNewAddressEditorState();
          focusNewAddressMapOnLocation(
            city,
            newAddressForm.querySelector('[name="address"]')
              ? newAddressForm.querySelector('[name="address"]').value.trim()
              : ""
          );
          if (isPickupDeliveryMode(newAddressDeliveryType)) {
            if (address.pickup_point_id) {
              pendingPickupPointId = String(address.pickup_point_id);
            }
            loadNewAddressPickupPoints();
            updateNewAddressEditorInteractivity();
            return;
          }
          if (newAddressEditorBootstrapActive) {
            markNewAddressEditorPickupPointsReady();
          } else {
            captureNewAddressEditorState();
          }
        }

        function resolveCitiesDeliveryTypeParam(type) {
          if (translations.normalizeDeliveryTypeKey) {
            return translations.normalizeDeliveryTypeKey(type);
          }
          return String(type || "pickup").trim().toLowerCase();
        }

        function getNewAddressCityInput() {
          return newAddressForm.querySelector('[name="city"]');
        }

        function getNewAddressCityListbox() {
          return document.getElementById("new-address-city-listbox");
        }

        function closeCityCombobox() {
          var listbox = getNewAddressCityListbox();
          var input = getNewAddressCityInput();
          if (listbox) {
            listbox.hidden = true;
          }
          if (input) {
            input.setAttribute("aria-expanded", "false");
          }
        }

        function selectCityOption(city) {
          var input = getNewAddressCityInput();
          if (input) {
            input.value = city;
          }
          renderCityComboboxOptions();
          closeCityCombobox();
          clearNewAddressPickupPointSelection();
          if (isPickupDeliveryMode(newAddressDeliveryType)) {
            loadNewAddressPickupPoints();
            return;
          }
          resetNewAddressPostalCodeState();
          captureNewAddressEditorState();
          focusNewAddressMapOnCity(city);
        }

        function getFilteredCities(query) {
          if (!newAddressCities.length) {
            return [];
          }
          var trimmed = String(query || "").trim();
          if (!trimmed) {
            return newAddressCities.slice();
          }
          var needle = trimmed.toLowerCase();
          return newAddressCities.filter(function (city) {
            return String(city).toLowerCase().indexOf(needle) !== -1;
          });
        }

        function renderCityComboboxOptions() {
          var listbox = getNewAddressCityListbox();
          var input = getNewAddressCityInput();
          if (!listbox || !input || input.disabled) {
            return;
          }
          var selectedCity = resolveSelectedCity(input.value);
          var filteredCities = getFilteredCities(input.value);
          listbox.innerHTML = "";
          filteredCities.forEach(function (city) {
            var option = document.createElement("li");
            option.className = "new-address-modal__combobox-option";
            option.setAttribute("role", "option");
            option.textContent = city;
            if (
              selectedCity &&
              String(city).toLowerCase() === selectedCity.toLowerCase()
            ) {
              option.classList.add("is-selected");
              option.setAttribute("aria-selected", "true");
            } else {
              option.setAttribute("aria-selected", "false");
            }
            option.addEventListener("mousedown", function (event) {
              event.preventDefault();
              selectCityOption(city);
            });
            listbox.appendChild(option);
          });
          listbox.hidden = filteredCities.length === 0;
          input.setAttribute("aria-expanded", filteredCities.length > 0 ? "true" : "false");
          var selectedNode = listbox.querySelector(".new-address-modal__combobox-option.is-selected");
          if (selectedNode) {
            selectedNode.scrollIntoView({ block: "nearest" });
          }
        }

        function openCityCombobox() {
          var input = getNewAddressCityInput();
          if (!input || input.disabled || !newAddressCities.length) {
            return;
          }
          renderCityComboboxOptions();
        }

        function setCityComboboxState(disabled, placeholder, value, options) {
          options = options || {};
          var input = getNewAddressCityInput();
          if (!input) {
            return;
          }
          input.disabled = !!disabled;
          input.placeholder = placeholder || "";
          input.value = value !== undefined ? value : "";
          closeCityCombobox();
          if (
            isPickupDeliveryMode(newAddressDeliveryType) &&
            !newAddressEditorBootstrapActive
          ) {
            if (!options.preservePickupSelection) {
              clearNewAddressPickupPointSelection();
            }
            loadNewAddressPickupPoints(
              options.preservePickupSelection ? { force: true } : undefined
            );
          }
        }

        function resolveSelectedCity(value) {
          var trimmed = String(value || "").trim();
          if (!trimmed || !newAddressCities.length) {
            return "";
          }
          var match = newAddressCities.find(function (city) {
            return String(city).toLowerCase() === trimmed.toLowerCase();
          });
          return match || "";
        }

        function loadNewAddressCities(options) {
          options = options || {};
          var cityInput = getNewAddressCityInput();
          if (!cityInput || !newAddressDeliveryType) {
            return;
          }
          if (!newAddressSelectedCountryAlpha2) {
            newAddressCities = [];
            setCityComboboxState(true, t("countriesLoading"), "", {
              preservePickupSelection: false,
            });
            return;
          }

          var preservedCity = "";
          if (options.preserveSharedCity) {
            if (newAddressEditorSharedCity) {
              preservedCity = newAddressEditorSharedCity;
            } else if (cityInput.value.trim()) {
              preservedCity = cityInput.value;
            }
          }

          var requestId = ++newAddressCitiesRequestId;
          newAddressCities = [];
          setCityComboboxState(true, t("citiesLoading"), preservedCity, {
            preservePickupSelection: !!options.preserveSharedCity,
          });

          api
            .getCities(
              newAddressSelectedCountryAlpha2,
              resolveCitiesDeliveryTypeParam(newAddressDeliveryType)
            )
            .then(function (cities) {
              if (requestId !== newAddressCitiesRequestId || newAddressModal.hidden) {
                return;
              }
              var list = Array.isArray(cities) ? cities : [];
              newAddressCities = list
                .map(function (city) {
                  return city ? String(city) : "";
                })
                .filter(function (city) {
                  return !!city;
                });
              if (!newAddressCities.length) {
                setCityComboboxState(true, t("noCitiesAvailable"), preservedCity, {
                  preservePickupSelection: !!options.preserveSharedCity,
                });
                if (newAddressEditorBootstrapActive) {
                  applyNewAddressPrefill();
                  markNewAddressEditorCitiesReady();
                  updateNewAddressEditorInteractivity();
                } else if (options.restoreTypeDraft) {
                  restoreNewAddressEditorStateForType(newAddressDeliveryType);
                }
                return;
              }
              setCityComboboxState(false, t("newAddressCityPlaceholder"), preservedCity, {
                preservePickupSelection: !!options.preserveSharedCity,
              });
              if (newAddressEditorBootstrapActive) {
                applyNewAddressPrefill();
                markNewAddressEditorCitiesReady();
                updateNewAddressEditorInteractivity();
              } else if (options.restoreTypeDraft) {
                restoreNewAddressEditorStateForType(newAddressDeliveryType);
              }
            })
            .catch(function () {
              if (requestId !== newAddressCitiesRequestId || newAddressModal.hidden) {
                return;
              }
              newAddressCities = [];
              setCityComboboxState(true, t("citiesLoadFailed"), preservedCity, {
                preservePickupSelection: !!options.preserveSharedCity,
              });
              if (newAddressEditorBootstrapActive) {
                applyNewAddressPrefill();
                markNewAddressEditorCitiesReady();
                updateNewAddressEditorInteractivity();
              } else if (options.restoreTypeDraft) {
                restoreNewAddressEditorStateForType(newAddressDeliveryType);
              }
            });
        }

        function initNewAddressCityCombobox() {
          var input = getNewAddressCityInput();
          if (!input || input.dataset.comboboxReady === "true") {
            return;
          }
          input.dataset.comboboxReady = "true";
          input.addEventListener("input", openCityCombobox);
          input.addEventListener("focus", openCityCombobox);
          input.addEventListener("click", openCityCombobox);
          input.addEventListener("blur", function () {
            window.setTimeout(function () {
              closeCityCombobox();
              var city = resolveSelectedCity(input.value);
              if (city) {
                if (isPickupDeliveryMode(newAddressDeliveryType)) {
                  loadNewAddressPickupPoints();
                } else {
                  focusNewAddressMapOnCity(city);
                }
              }
            }, 150);
          });
          input.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
              closeCityCombobox();
            }
          });
        }

        function initNewAddressPhoneField() {
          var input = getContactPhoneInput();
          if (!input || input.dataset.phoneBound === "true") {
            return;
          }
          input.dataset.phoneBound = "true";
          input.addEventListener("input", sanitizeContactPhoneInput);
        }

        function initNewAddressAddressField() {
          if (!newAddressForm) {
            return;
          }
          var input = newAddressForm.querySelector('[name="address"]');
          if (!input || input.dataset.mapBound === "true") {
            return;
          }
          input.dataset.mapBound = "true";
          var mapFocusTimer = null;
          function scheduleMapFocus() {
            if (!isPickupDeliveryMode(newAddressDeliveryType)) {
              newAddressPostalCode = "";
              newAddressPostalCodeBeforeLookup = "";
            }
            window.clearTimeout(mapFocusTimer);
            mapFocusTimer = window.setTimeout(function () {
              focusNewAddressMapOnAddressField();
            }, 400);
          }
          input.addEventListener("input", scheduleMapFocus);
          input.addEventListener("change", scheduleMapFocus);
        }

        function initNewAddressCountryCombobox() {
          var input = getNewAddressCountryInput();
          if (!input || input.dataset.comboboxReady === "true") {
            return;
          }
          input.dataset.comboboxReady = "true";
          input.addEventListener("input", function () {
            delete input.dataset.selectedCountryAlpha2;
            openCountryCombobox({ showAll: false });
          });
          input.addEventListener("focus", function () {
            openCountryCombobox({ showAll: true });
          });
          input.addEventListener("click", function () {
            openCountryCombobox({ showAll: true });
          });
          input.addEventListener("blur", function () {
            window.setTimeout(function () {
              closeCountryCombobox();
              var resolved = resolveSelectedCountry(input.value);
              if (resolved && resolved !== newAddressSelectedCountryAlpha2) {
                setNewAddressCountry(resolved);
                return;
              }
              if (resolved) {
                syncCountryComboboxValue(resolved);
                return;
              }
              if (newAddressSelectedCountryAlpha2) {
                syncCountryComboboxValue(newAddressSelectedCountryAlpha2);
                return;
              }
              input.value = "";
              updateCountryComboboxFlag("");
            }, 150);
          });
          input.addEventListener("keydown", function (event) {
            if (event.key === "Escape") {
              closeCountryCombobox();
            }
          });
        }

        function setNewAddressDeliveryType(type, options) {
          var userSwitch = !options || !options.force;
          if (userSwitch && isNewAddressEditorLocked()) {
            return;
          }
          if (userSwitch && newAddressDeliveryType) {
            captureNewAddressEditorState();
          }
          if (userSwitch && !isPickupDeliveryMode(type)) {
            newAddressEditorRequiresPickupPoints = false;
          }
          newAddressDeliveryType = type;
          if (!newAddressDeliveryTypeRow) {
            loadNewAddressCities({
              preserveSharedCity: userSwitch,
              restoreTypeDraft: userSwitch,
            });
            return;
          }
          newAddressDeliveryTypeRow.querySelectorAll(".delivery-type-btn").forEach(function (btn) {
            var isActive = btn.getAttribute("data-type") === type;
            btn.classList.toggle("is-active", isActive);
            btn.setAttribute("aria-pressed", isActive ? "true" : "false");
          });
          setNewAddressDeliveryTypeButtonsDisabled(isNewAddressDeliveryTypeSelectorLocked());
          loadNewAddressCities({
            preserveSharedCity: userSwitch,
            restoreTypeDraft: userSwitch,
          });
          updateNewAddressFormForDeliveryType();
        }

        function renderNewAddressDeliveryTypeSelector(initialType) {
          if (!newAddressDeliveryTypeRow) {
            return;
          }
          var types = resolveNewAddressTypeOptions();
          newAddressDeliveryTypeRow.innerHTML = "";
          types.forEach(function (type) {
            var button = document.createElement("button");
            button.type = "button";
            button.className = "delivery-type-btn";
            button.setAttribute("data-type", type);
            button.setAttribute("aria-pressed", "false");
            button.textContent = labelForType(type);
            button.addEventListener("click", function () {
              setNewAddressDeliveryType(type);
            });
            newAddressDeliveryTypeRow.appendChild(button);
          });
          var defaultType = resolveMatchingTypeOption(initialType || selectedType, types);
          setNewAddressDeliveryType(defaultType || null, { force: true });
          setNewAddressDeliveryTypeButtonsDisabled(isNewAddressDeliveryTypeSelectorLocked());
          newAddressDeliveryTypeRow.setAttribute("aria-label", t("deliveryTypeLabel"));
        }

        function openNewAddressModal() {
          openAddressFormModal({
            prefill: findActiveAddress(),
          });
        }

        function closeNewAddressModal() {
          newAddressModal.hidden = true;
          newAddressPrefill = null;
          pendingPickupPointId = null;
          editingAddressId = null;
          newAddressIsCopy = false;
          newAddressEditorBootstrapActive = false;
          newAddressEditorCitiesReady = false;
          newAddressEditorPickupPointsReady = false;
          resetNewAddressPickupPointsEditorState();
          resetNewAddressDeliveryTypeDrafts();
          newAddressDestinationCountries = [];
          newAddressSelectedCountryAlpha2 = "";
          newAddressPendingPrefillCountryAlpha2 = "";
          newAddressSaving = false;
          resetNewAddressPostalCodeState();
          updateNewAddressEditorInteractivity();
          newAddressModalError.hidden = true;
          newAddressModalError.textContent = "";
          if (addressModal.hidden) {
            document.body.style.overflow = "";
          }
        }

        function getNewAddressValidationError() {
          var cityInput = getNewAddressCityInput();
          var cityRaw = cityInput ? cityInput.value.trim() : "";
          var city = resolveSelectedCity(cityRaw);
          var isPickup = isPickupDeliveryMode(newAddressDeliveryType);
          var pickupPoint = isPickup ? resolveSelectedPickupPoint() : null;
          var courierAddress = newAddressForm.querySelector('[name="address"]').value.trim();
          var contactFirstName = getContactFirstNameInput()
            ? getContactFirstNameInput().value.trim()
            : "";
          var contactLastName = getContactLastNameInput()
            ? getContactLastNameInput().value.trim()
            : "";
          var contactEmail = getContactEmailInput()
            ? getContactEmailInput().value.trim()
            : "";
          var contactPhoneRaw = getContactPhoneInput()
            ? getContactPhoneInput().value.trim()
            : "";

          if (!city) {
            return t("newAddressCityInvalid");
          }
          if (!newAddressSelectedCountryAlpha2) {
            return t("noCountriesAvailable");
          }
          if (isPickup) {
            if (!pickupPoint) {
              return t("newAddressPickupPointInvalid");
            }
          } else if (!courierAddress) {
            return t("newAddressLineRequired");
          }
          if (!contactFirstName) {
            return t("newAddressContactFirstNameRequired");
          }
          if (!contactLastName) {
            return t("newAddressContactLastNameRequired");
          }
          if (!contactEmail) {
            return t("newAddressContactEmailRequired");
          }
          if (!isContactEmailValid(contactEmail)) {
            return t("newAddressContactEmailInvalid");
          }
          if (!contactPhoneRaw) {
            return t("newAddressContactPhoneRequired");
          }
          if (!isContactPhoneValid(contactPhoneRaw)) {
            return t("newAddressContactPhoneInvalid");
          }
          if (
            !isAllowExternalPhoneNumber() &&
            !isContactPhoneMatchingSelectedCountry(contactPhoneRaw)
          ) {
            return t("newAddressContactPhoneCountryInvalid");
          }
          if (isNewAddressPostalCodeBlocking()) {
            if (newAddressPostalCodePending) {
              return "";
            }
            return t("newAddressPostalCodeUndetermined");
          }
          return "";
        }

        function saveNewAddress() {
          if (newAddressSaving || !newAddressDeliveryType) {
            return;
          }

          var customerId = readCustomerId();
          if (!customerId) {
            newAddressModalError.hidden = false;
            newAddressModalError.textContent = t("noCustomerId");
            return;
          }

          var validationError = getNewAddressValidationError();
          if (validationError) {
            newAddressModalError.hidden = false;
            newAddressModalError.textContent = validationError;
            return;
          }

          var cityInput = getNewAddressCityInput();
          var city = resolveSelectedCity(cityInput ? cityInput.value : "");
          var isPickup = isPickupDeliveryMode(newAddressDeliveryType);
          var pickupPoint = isPickup ? resolveSelectedPickupPoint() : null;
          var address = isPickup
            ? getPickupPointAddressLine(pickupPoint)
            : newAddressForm.querySelector('[name="address"]').value.trim();
          var contactFirstName = getContactFirstNameInput()
            ? getContactFirstNameInput().value.trim()
            : "";
          var contactLastName = getContactLastNameInput()
            ? getContactLastNameInput().value.trim()
            : "";
          var contactEmail = getContactEmailInput()
            ? getContactEmailInput().value.trim()
            : "";
          var contactPhoneRaw = getContactPhoneInput()
            ? getContactPhoneInput().value.trim()
            : "";
          var contactPhone = formatContactPhoneForSave(contactPhoneRaw);

          if (!Number.isFinite(resolveSelectedCountryNumericCode())) {
            newAddressModalError.hidden = false;
            newAddressModalError.textContent = t("companyCountryUnavailable");
            return;
          }

          var payload = {
            customer_id: customerId,
            delivery_type: newAddressDeliveryType,
            country: resolveSelectedCountryNumericCode(),
            city: city,
            postal_code: resolveNewAddressPostalCodeForSave(),
            address: address,
            is_active: editingAddressId
              ? Boolean((findAddressById(editingAddressId) || {}).is_active)
              : !newAddressIsCopy,
            contact_info: {
              first_name: contactFirstName,
              last_name: contactLastName,
              email: contactEmail,
              phone: contactPhone,
            },
          };

          if (isPickup && pickupPoint) {
            payload.pickup_point_id = pickupPoint.id;
            payload.provider_code = pickupPoint.provider_code || null;
          } else {
            payload.provider_code = null;
          }

          newAddressSaving = true;
          newAddressModalSave.disabled = true;
          newAddressModalError.hidden = true;
          newAddressModalError.textContent = "";

          var saveRequest = editingAddressId
            ? api.updateDeliveryAddress(editingAddressId, payload)
            : api.createDeliveryAddress(payload);

          saveRequest
            .then(function (saved) {
              if (!saved) {
                throw new Error("save_failed");
              }
              closeNewAddressModal();
              modalAutoOpenedForType = null;
              return loadDeliveryAddresses().then(function () {
                if (!addressModal.hidden) {
                  renderAddressModalList();
                }
                renderAddressUi();
              });
            })
            .catch(function () {
              newAddressModalError.hidden = false;
              newAddressModalError.textContent = editingAddressId
                ? t("addressUpdateFailed")
                : newAddressIsCopy
                  ? t("addressCopyFailed")
                  : t("newAddressCreateFailed");
              newAddressSaving = false;
              syncNewAddressSaveButtonState();
            });
        }

        function applyTranslations() {
          document.documentElement.lang = locale;
          document.querySelectorAll("[data-i18n]").forEach(function (node) {
            var key = node.getAttribute("data-i18n");
            if (key) {
              node.textContent = t(key);
            }
          });
          document.querySelectorAll("[data-i18n-placeholder]").forEach(function (node) {
            var key = node.getAttribute("data-i18n-placeholder");
            if (key) {
              node.placeholder = t(key);
            }
          });
          renderAddButtonLabel();
          var langGroup = document.querySelector(".lang-switch");
          if (langGroup) {
            langGroup.setAttribute("aria-label", t("language"));
          }
          if (row) {
            row.setAttribute("aria-label", t("deliveryTypeLabel"));
            if (row.classList.contains("is-loading")) {
              row.textContent = t("loading");
            }
          }
          document.querySelectorAll(".lang-switch__btn").forEach(function (btn) {
            btn.classList.toggle("is-active", btn.getAttribute("data-lang") === locale);
          });
          if (loadedTypes.length && row) {
            row.querySelectorAll(".delivery-type-btn").forEach(function (btn) {
              var type = btn.getAttribute("data-type");
              if (type) {
                btn.textContent = labelForType(type);
              }
            });
          }
          if (!addressModal.hidden) {
            addressModalTitle.textContent = t("changeAddressTitle");
            addressModalConfirm.textContent = t("done");
            renderAddButtonLabel();
            renderAddressModalList();
          }
          if (!newAddressModal.hidden) {
            newAddressModalTitle.textContent = t("newAddressTitle");
            newAddressModalSave.textContent = t("save");
            newAddressModalCancel.textContent = t("cancel");
            if (newAddressDeliveryTypeRow) {
              newAddressDeliveryTypeRow.setAttribute("aria-label", t("deliveryTypeLabel"));
              newAddressDeliveryTypeRow.querySelectorAll(".delivery-type-btn").forEach(function (btn) {
                var type = btn.getAttribute("data-type");
                if (type) {
                  btn.textContent = labelForType(type);
                }
              });
            }
            if (newAddressDestinationCountries.length) {
              syncCountryComboboxDisplay();
            }
            renderAddButtonLabel();
            if (newAddressDeliveryType && newAddressSelectedCountryAlpha2) {
              loadNewAddressCities();
              if (isPickupDeliveryMode(newAddressDeliveryType)) {
                loadNewAddressPickupPoints();
              }
            }
            refreshNewAddressPostalCodeState();
          }
          renderAddressUi();
        }

        function setLocale(nextLocale) {
          var normalized = normalizeLocale(nextLocale);
          if (!normalized || normalized === locale) {
            return;
          }
          locale = normalized;
          try {
            var params = new URLSearchParams(window.location.search || "");
            params.set("lang", locale);
            var query = params.toString();
            var nextUrl =
              window.location.pathname +
              (query ? "?" + query : "") +
              window.location.hash;
            window.history.replaceState(null, "", nextUrl);
          } catch (e) {
            // ignore
          }
          applyTranslations();
          if (ratesLoadState !== "idle") {
            renderShippingRatesPanel();
          } else {
            updateShippingRatesConfirmButton();
          }
        }

        function showError(message) {
          errorNode.hidden = false;
          errorNode.textContent = message;
          deliveryTypesLoadState = "error";
          if (row) {
            row.className = "delivery-type-row is-empty";
            row.textContent = "—";
          }
          renderAddressUi();
        }

        function setActiveButton(type, options) {
          options = options || {};
          if (!setSelectedDeliveryType(type)) {
            return;
          }
          if (options.skipAddressSync) {
            renderAddressUi();
            return;
          }
          handleDeliveryTypeChange(type);
        }

        function renderButtons(types) {
          loadedTypes = types.slice();
          deliveryTypesLoadState = "ready";
          if (!row) {
            renderAddressUi();
            return;
          }
          row.className = "delivery-type-row";
          row.innerHTML = "";

          types.forEach(function (type) {
            var button = document.createElement("button");
            button.type = "button";
            button.className = "delivery-type-btn";
            button.setAttribute("data-type", type);
            button.setAttribute("aria-pressed", "false");
            button.textContent = labelForType(type);
            button.addEventListener("click", function () {
              setActiveButton(type);
            });
            row.appendChild(button);
          });

          var initialType = resolveInitialDeliveryType(types);
          if (initialType) {
            setActiveButton(initialType, { skipAddressSync: true });
            return;
          }
          renderAddressUi();
        }

        function loadDeliveryAddresses(options) {
          options = options || {};
          var silent = !!options.silent;
          var customerId = readCustomerId();
          if (!customerId) {
            addressLoadState = "no-customer";
            renderAddressUi();
            return Promise.resolve();
          }

          if (!silent) {
            addressLoadState = "loading";
            renderAddressUi();
          }

          return api
            .listDeliveryAddresses(customerId)
            .then(function (addresses) {
              loadedAddresses = Array.isArray(addresses) ? addresses : [];
              normalizeLoadedAddressesActiveState();
              addressLoadState = "ready";
              if (!syncSelectedTypeWithActiveAddress()) {
                renderAddressUi();
              }
            })
            .catch(function () {
              if (!silent) {
                addressLoadState = "error";
              }
              renderAddressUi();
            });
        }

        function bindOptionalClick(node, handler) {
          if (node) {
            node.addEventListener("click", handler);
          }
        }

        document.querySelectorAll(".lang-switch__btn").forEach(function (btn) {
          btn.addEventListener("click", function () {
            setLocale(btn.getAttribute("data-lang"));
          });
        });

        bindOptionalClick(addressModalConfirm, closeAddressModal);
        bindOptionalClick(shippingRatesConfirm, confirmSelectedRate);
        bindOptionalClick(deliveryAddressEdit, openAddressModal);
        bindOptionalClick(addressModalAdd, openNewAddressModal);
        if (addressModalFilter) {
          addressModalFilter.addEventListener("input", function () {
            if (!addressModal.hidden) {
              renderAddressModalList();
            }
          });
        }
        if (addressModalList) {
          addressModalList.addEventListener("scroll", closeAddressItemMenus, {
            passive: true,
          });
        }
        if (addressModal) {
          bindOptionalClick(
            addressModal.querySelector("[data-action=close-modal]"),
            closeAddressModal
          );
        }
        bindOptionalClick(newAddressModalSave, saveNewAddress);
        bindOptionalClick(newAddressModalCancel, closeNewAddressModal);
        initNewAddressCountryCombobox();
        initNewAddressCityCombobox();
        initNewAddressPhoneField();
        initNewAddressAddressField();
        initNewAddressPickupPointCombobox();
        if (newAddressModal) {
          bindOptionalClick(
            newAddressModal.querySelector("[data-action=close-new-address-modal]"),
            closeNewAddressModal
          );
        }
        document.addEventListener("click", function (event) {
          if (
            openAddressMenuId != null &&
            !event.target.closest(".address-modal__item-menu")
          ) {
            closeAddressItemMenus();
          }
        });
        document.addEventListener("keydown", function (event) {
          if (event.key !== "Escape") {
            return;
          }
          if (openAddressMenuId != null) {
            closeAddressItemMenus();
            return;
          }
          if (!newAddressModal.hidden) {
            closeNewAddressModal();
            return;
          }
          if (!addressModal.hidden) {
            closeAddressModal();
          }
        });

        function loadCompanyCountry() {
          if (!cfg.companyId) {
            return Promise.resolve();
          }
          return api
            .getCompany()
            .then(function (company) {
              var code = company && company.country_code;
              companyCountryCode = code != null ? parseInt(code, 10) : null;
              companyCountryAlpha2 =
                translations.numericCountryCodeToAlpha2 &&
                Number.isFinite(companyCountryCode)
                  ? translations.numericCountryCodeToAlpha2(companyCountryCode)
                  : "";
              renderAddButtonLabel();
              if (!newAddressModal.hidden) {
                refreshNewAddressMapLayout();
              }
            })
            .catch(function () {
              companyCountryCode = null;
              companyCountryAlpha2 = "";
              renderAddButtonLabel();
              if (!newAddressModal.hidden) {
                refreshNewAddressMapLayout();
              }
            });
        }

        function createApiClient() {
          return window.FiluetShipApi.create({
            deliveryCoreUrl: cfg.deliveryCoreUrl || "",
            authIdentityUrl: cfg.authIdentityUrl || "",
            clientCoreUrl: cfg.clientCoreUrl || "",
            apiKey: cfg.apiKey || "",
            companyId: cfg.companyId || "",
            environment: cfg.environment || "TEST",
          });
        }

        function parseRefreshIntervalMinutes(value) {
          var minutes = Number(value);
          if (!Number.isFinite(minutes) || minutes <= 0) {
            return 0;
          }
          return minutes;
        }

        function stopWidgetRefreshTimer() {
          if (widgetRefreshTimerId != null) {
            window.clearInterval(widgetRefreshTimerId);
            widgetRefreshTimerId = null;
          }
        }

        function refreshWidgetData() {
          if (
            !api ||
            newAddressSaving ||
            modalConfirming ||
            selectRateState === "submitting" ||
            !newAddressModal.hidden
          ) {
            return;
          }

          loadDeliveryAddresses({ silent: true }).then(function () {
            if (isShipmentConfirmationMode() && !calculationPayloadConfirmed) {
              loadShippingRates({ force: true });
            }
          });
        }

        function startWidgetRefreshTimer() {
          stopWidgetRefreshTimer();
          var minutes = parseRefreshIntervalMinutes(cfg.refreshIntervalMinutes);
          if (!minutes) {
            return;
          }
          widgetRefreshTimerId = window.setInterval(refreshWidgetData, minutes * 60 * 1000);
        }

        function startWidget() {
          try {
            applyTranslations();
          } catch (e) {
            showError(t("loadFailed"));
            return;
          }

          api = createApiClient();

          api
            .ensureAccessToken()
            .then(function () {
              loadCompanyCountry();
              return api.getDeliveryTypes();
            })
            .then(function (types) {
              try {
                var list = Array.isArray(types) ? types : [];
                if (!list.length) {
                  showError(t("noDeliveryTypes"));
                  return;
                }
                renderButtons(list);
              } catch (e) {
                showError(t("loadFailed"));
              }
            })
            .catch(function () {
              showError(t("loadFailed"));
            });

          loadDeliveryAddresses();
          startWidgetRefreshTimer();
        }

        function launchWidget() {
          try {
            startWidget();
          } catch (e) {
            showError(t("loadFailed"));
          }
        }

        window.addEventListener("beforeunload", stopWidgetRefreshTimer);

        calculationPayloadId =
          readCalculationPayloadIdFromUrl() ||
          String(cfg.calculationPayloadId || "").trim();
        widgetMode = calculationPayloadId
          ? "shipment-confirmation"
          : "delivery-settings";
        if (calculationPayloadId) {
          cfg.calculationPayloadId = calculationPayloadId;
          var bootstrapApi = createApiClient();
          bootstrapApi
            .ensureAccessToken()
            .then(function () {
              return bootstrapApi.getCalculationPayload(calculationPayloadId);
            })
            .then(function (payload) {
              if (!payload) {
                throw new Error("calculation_payload_missing");
              }
              if (payload.id != null && String(payload.id).trim()) {
                calculationPayloadId = String(payload.id).trim();
                cfg.calculationPayloadId = calculationPayloadId;
              }
              applyCalculationPayloadToConfig(payload);
              handleCalculationPayloadConfirmedState(payload);
              launchWidget();
            })
            .catch(function () {
              showError(t("calculationPayloadLoadFailed"));
            });
        } else {
          launchWidget();
        }
      })();